import {
  compassImageUrl,
  courtImageUrl,
  lightBulbImageUrl,
  lightningImageUrl,
  peopleImageImageUrl,
  shuffleImageUrl,
  TmiType,
} from '@app/app/page-modules/personality-indicator/pi-questions/models/pi-questions.model';

export const tmiTypesReportAr: {
  [trait: string]: TmiType;
} = {
  ENFJ: {
    shortDescription: 'المانح',
    atWorkParagraphs: {
      effectiveness: [
        'وضع تركيز أكبر على إنجاز المهام',
        'كونه أكثر فضولًا وتشككًا ونقدًا',
        'تقليل الولاء للأشخاص أو القضايا التي قد لا تستحق ذلك',
        'التصرف بشكل عفوي في كثير من الأحيان',
        'تقليل التسلط على الأشخاص الذين يهتمون بهم، والسماح لهم بارتكاب أخطائهم والتعلم منها',
        'قضاء وقت أقل في المشاكل الشخصية',
        'البناء على نقاط قوتهم لتوفير الهيكل والتنظيم لفريقهم',
        'بناء على نقاط قوتهم لتحقيق التوافق من خلال التوضيح والتعاون والتآزر',
        'إدراك أن النظرية لا تعمل دائمًا',
        'التركيز على الجوانب الإيجابية بدلاً من السلبية',
        'إدراك أن القرارات يجب أن تتخذ أحيانًا بمعلومات غير كاملة',
      ],
      teamLeader: [
        'تنشيط الفريق وإلهامه بالحماس والفكاهة',
        'اتباع أسلوب قيادة قائم على المساواة',
        'إعطاء أهمية متساوية للعملية والمحتوى',
        'إنشاء تنظيم واضح للفريق',
        'ضمان بقاء الفريق على المسار الصحيح من خلال الاستفادة من جداول الأعمال والجدول الزمني وإنجاز المهام',
        'الاستماع إلى جميع أعضاء الفريق ومراعاة كل رأي',
        'تسهيل التعاون والاستخدام الفعال لجميع الموارد المتاحة للفريق',
        'قيادة الفريق من خلال البصيرة والحساسية',
      ],
      conflicts: [
        'من المحتمل أن ينزعجوا من أعضاء الفريق الذين يأتون إلى الاجتماعات دون استعداد',
        'قد يتعارضون مع الأشخاص الذين يرونهم غير ملتزمين بحل مشاكل الفريق',
        'أقل احتمالًا للتوافق مع الأشخاص الذين يظهرون عدم احترامهم لوقت الآخرين بالتأخر عن الحضور والمغادرة المبكرة',
        'قد يتعارضون مع الأشخاص الذين لا يبذلون جهدًا كافيًا للتعاون',
        'قد يكون لديهم قدر ضئيل من التسامح مع الأشخاص الذين لا يأخذون في الاعتبار تأثير قراراتهم على الآخرين',
        'قد يكون أكثر عرضة للإزعاج من الأشخاص الذين لا يخصصون وقتًا كافيًا للمجاملات الشخصية',
      ],
      stressAdvisor: [
        'يصبح أكثر انتقادًا ويجد عيبًا في كل شيء',
        'يصبح مهووسًا بضمان حب الجميع له وكسب رضاهم',
        'يجد نفسه متسلطًا ويميل إلى تنظيم كل شيء',
      ],
      workEnvironment: ['يفضل بيئة عمل مزدحمة وتفاعلية ويسعى إلى تحقيق الانسجام', 'يفضل أن يكون لديه خطة وروتين ويلتزم بها'],
      underStress: [],
      underSevereStress: [],
    },
    atWorkTagLine: 'ينشط الفريق ويُلهمه بحماس وروح الدعابة',
    atWorkSneakPeek: 'إحدى الطرق التي يمكنهم من خلالها تحسين فعالية عملهم هي أن يكونوا أكثر فضولًا وتشككًا ونقدًا',
    withOthersTagLine: 'منفتح وودود واجتماعي',
    withOthersSneakPeek: 'قد يشعر %fname بالراحة أكثر عند تولي الأدوار التالية في فريقه: المنظم، مولد الأفكار، المنسق',
    withOthersParagraphs: {
      strengths: [
        'اجتماعي ومتفتح',
        'محبوب بسهولة وشعبي',
        'يُظهر اهتمامًا كبيرًا بالأشخاص من حوله',
        'يُنظر إليه عادةً على أنه شخص دافئ ومتعاطف ومهتم بالآخرين',
        'يقيّم وجهة نظر الآخرين بحساسية ولباقة',
        'يسهل عليه تكوين الصداقات',
        'مفكر حر ومنفتح',
        'متناغم',
        'متساهل',
        'يقدر النزاهة تقديراً عالياً',
      ],
      weakSpotsWithOthers: [
        'قد يواجه صعوبة في مواجهة الآخرين',
        'قد يتساهل مع الآخرين على حساب نفسه',
        'قد يشعر بالاستياء إذا شعر أنه تم استغلاله',
        'قد يشعر بالإحباط إذا لم يتم تقدير أفكاره وآرائه',
        'قد يرى الآخرون أنه غير منظم بعض الشيء',
      ],
    },
    typeTagLine: '--',
    typeSneakPeek: 'نوع شخصية %fname يُسمى ENFP. بعض الكلمات المفتاحية المرتبطة به هي متحمس، صاحب رؤية، أو دافئ.',
    typeKeywords: [
      '1. متحمس',
      '2. نشط',
      '3. داعم',
      '4. اجتماعي',
      '5. صاحب رؤية',
      '6. موجه نحو الناس',
      '7. إبداعي',
      '8. مهتم',
      '9. دافئ',
      '10. متعاطف',
      '11. عفوي',
      '12. مرونة',
    ],
    typePersonalStrengths: [
      'يحفز الآخرين ويشجعهم',
      'يرى الحياة مليئة بالإمكانيات',
      'يسهل التواصل بين الناس',
      'مبدع',
      'يبتكر حلولاً مبتكرة للمشاكل',
      'يدرك ما يهم الآخرين',
      'الارتجال',
      'غالبًا ما يتمتع بموهبة اللغة',
      'قادر على رؤية الصورة الكبيرة',
      'قادر على الربط بين الأحداث والمعلومات بسرعة كبيرة',
      'يفكر باستعارات',
      'طبيعي في العصف الذهني',
      'متعاون بطبيعته وحريص على العمل من أجل الصالح العام',
      'مهارات قوية في التعامل مع الناس',
      'القدرة على التكيف مع التغيير',
      'جيد في الشرح ومساعدة الآخرين على الفهم',
      'جيد في تعزيز التغيير من خلال بناء العلاقات',
      'مثالي، نظرة إيجابية للحياة',
    ],
    typeWeakSpots: [
      'حساسية مفرطة تجاه الصراع',
      'يحتاج إلى الكثير من التأكيد من الآخرين',
      'أحيانًا يفرط في التفسير وقد يربط بين الأحداث والمعلومات بسرعة كبيرة',
      'يرغب في التشجيع والتقدير المستمرين',
      'متحمس في البداية ولكن قد يفتقر إلى المتابعة',
      'قد يؤخر اتخاذ القرار لإبقاء الخيارات مفتوحة',
      'يجد صعوبة في التحضير المسبق',
      'يواجه صعوبة في الاهتمام بالتفاصيل',
      'لا يتحمل الروتين',
    ],
    description:
      'ENFP هو شخص اجتماعي، وحماسه يجعله يجد نفسه كثيرًا في صحبة الآخرين. من المرجح أن يوصف بأنه روح الحفلة. ENFP شخص فضولي ومستقل، ويستمتع بالتغيير والمرونة، ولكنه يفقد التركيز بسهولة. ENFP لديه الكثير من "الأفكار الكبيرة" ويسعى إلى العمل. يريد أن يشارك الجميع في أفكاره وخططه لإضافة المزيد من الإبداع والابتكار. يهتم بشدة بالآخرين وبما يفكر فيه الآخرون، وقادر على إضفاء البهجة على حياة من حوله.',
    individualTypeByLetters: 'مُلهم',
    individualDescription:
      'بصفته ملهمًا، من المرجح أن يكون شخصًا اجتماعيًا، وحماسه يعني أنه يجد نفسه كثيرًا في صحبة الآخرين. من المرجح أن يوصف بأنه روح الحفلة. إنهم فضوليون ومستقلون ويميلون إلى الاستمتاع بالتغيير والمرونة، ولكنهم قد يفقدون التركيز بسهولة. من المرجح أن يكون لديهم الكثير من "الأفكار الكبيرة" ويسعون إلى العمل، ويريدون إشراك الجميع في أفكارهم وخططهم لإضافة المزيد من الإبداع والابتكار. من المرجح أن يهتموا بشدة بالآخرين وبما يفكر فيه الآخرون، ويكونوا قادرين على إضفاء البهجة على حياة من حولهم.',
  },
  ENTJ: {
    shortDescription: 'التنفيذي',
    atWorkParagraphs: {
      effectiveness: [
        'التحلي بمزيد من الصبر مع الأشخاص الذين قد يحتاجون إلى وقت أطول لفهم الأفكار المعقدة والمجردة',
        'تطوير قدر أكبر من التسامح تجاه ما يُنظر إليه على أنه عدم كفاءة أو عدم فعالية من جانب الآخرين',
        'أن تكون أقل انتقادًا وأكثر تقبلاً لنقاط قوة الآخرين وضعفهم',
        'عدم وضع معايير غير قابلة للتحقيق',
        'الاعتراف بحاجة الآخرين للدعم العاطفي',
        'إيجاد طرق بناءة للنقد',
        'تنمية احترام صحي للتفاصيل',
        'محاولة الاستماع أكثر والتحدث أقل',
        'تخصيص المزيد من الوقت للتفكير الخاص',
      ],
      teamLeader: [
        'القيام بدور تنسيقي',
        'تعزيز فهم المهام وإنجازها من خلال توفير نماذج',
        'توصيل رؤيتهم بطريقة تحفز الآخرين على المشاركة الفعالة',
        'كن أكثر موضوعية لتوجيه جهود وأنشطة الآخرين نحو هدف أو غاية عامة',
        'توفير فهم واضح للأهداف العامة',
        'أن يكون منفتحًا ومن ثم يقدر المساهمات من أي مصدر',
        'أن يكون ديمقراطياً ويشجع المشاركة',
        'تحمل المسؤولية عن قراراتهم',
        'التفاني التام في المهمة',
        'تحفيز الآخرين من خلال وضع معايير عالية',
      ],
      teamLeaderFlipSide: [
        'قد يُنظر إليك أحيانًا على أنك غير قادر على المنافسة، أو غير قوي بما يكفي، أو غير طموح.',
        'أحيانًا يُنظر إليك على أنك متحفظ أو منعزل',
        'لا تتوقف لجمع المعلومات أو استكشاف البدائل الأخرى.',
        'قد يبدو متسلطًا للغاية',
      ],
      conflicts: [
        'قد ينزعج من الأشخاص الذين يعتبرهم غير أكفاء',
        'قد يشعر بالإحباط من الأشخاص الذين يظهرون عدم التزامهم بأهداف الفريق',
        'أكثر عرضة للإزعاج من الأشخاص الذين يظهرون موقفًا غير جاد ويبدون غير منظمين للغاية',
        'من المرجح أن يجدوا صعوبة في العمل مع الأشخاص الذين يستمرون في مناقشة مشكلة ما على الرغم من توضيحها بالفعل',
        'قد ينزعجون من الأشخاص الذين ينشغلون بمناقشة تفاصيل يعتبرونها غير ذات صلة بالمساهمة في تحقيق الهدف',
        'من المحتمل أن يتعارضوا مع الأشخاص الذين يفتقرون إلى منظور منهجي ونهج منهجي لاستخدام الوقت والموارد',
      ],
      stressAdvisor: [],
      workEnvironment: ['منظم ومنظم', 'موجه نحو المستقبل', 'موجه نحو الهدف'],
      underStress: ['قد يصبحون شديدي النقد لأنفسهم وللآخرين', 'قد يغضبون ويصبحون متسلطين دون التفكير كثيرًا في تأثير سلوكهم على الآخرين'],
      underSevereStress: ['قد يشعرون بأنهم محاصرون ومفرطون في العاطفة', 'قد يفهمون التعليقات البريئة على أنها هجمات شخصية'],
    },
    atWorkTagLine: '---',
    atWorkSneakPeek:
      'إحدى الطرق التي يمكن أن يعزز بها %fname فعالية عمله هي أن يكون أقل انتقادًا وأكثر تقبلاً لنقاط قوة الآخرين ونقاط ضعفهم',
    withOthersTagLine: '---',
    withOthersSneakPeek: 'قد يشعر %fname براحة أكبر عند تولي الأدوار التالية في فريقه: المنظم، مولد الأفكار، الناقد',
    withOthersParagraphs: {
      strengths: [
        'اجتماعي ومتفتح',
        'المنطق والتحليل أمران بالغا الأهمية',
        'نقدية وسريعة في طرح الأسئلة',
        'مستعدون لتحدي أنفسهم والآخرين',
        'حازم وحاسم',
        'يتواصل بشكل مباشر',
        'يحب تنظيم الأشخاص وتولي المسؤولية',
        'يمكن الاعتماد عليه وموثوق به',
        'يقدر العدالة',
      ],
      weakSpotsWithOthers: [
        'قد ينظر إليه الأشخاص الأقل حزماً على أنه متسلط أو متعجرف أو متعصب',
        'قد يبدو أنهم يضعون أنفسهم في مكانة عالية جدًا',
        'قد يستاء بعض الأشخاص من ميلهم إلى تولي زمام الأمور',
        'قد يبدون باردين وغير شخصيين',
      ],
    },
    typeTagLine: '--',
    typeSneakPeek: 'نوع شخصية %fname يُسمى ENTJ. بعض الكلمات المفتاحية المرتبطة به هي المخطط، الصريح أو المتحمس',
    typeKeywords: [
      '1. المخطط',
      '2. صاحب الرؤية',
      '3. المنظم',
      '4. المنطقي',
      '5. التحليلي',
      '6. المنظّر',
      '7. غير الملتزم بالتقاليد',
      '8. المجادل',
      '9. صريح وحماسي',
      '10. حاسم',
      '11. موضوعي',
      '12. متحمس',
    ],
    typePersonalStrengths: [
      'أن يكون موجهاً نحو الأهداف ومنظماً ويحقق النتائج كما هو متوقع',
      'اتخاذ منظور طويل الأمد عند حل المشكلات من خلال التركيز على الأفكار المتعلقة بالصورة الكبيرة',
      'تحديد الإجراءات والسياسات غير المنطقية وغير الفعالة',
      'تحليل المشكلات وإضفاء النظام المنطقي عليها',
      'تطوير نظريات أو نماذج أو أفكار أو أنظمة جديدة لحل المشكلات',
      'انتقاد الحلول المحتملة بموضوعية',
      'تنفيذ الحلول',
      'إضفاء الطاقة والحماس على المهام',
      'تعلم أشياء جديدة وتوسيع المعرفة ومشاركتها مع الآخرين',
      'عرض الأفكار',
      'تقديم المشورة المتخصصة',
      'التركيز على ما يمكن أن يكون، وليس ما هو موجود بالفعل',
      'التفكير المفاهيمي والمجرد',
      'اتخاذ القرارات',
      'تطبيق المعرفة',
    ],
    typeWeakSpots: [
      'قد يبدو أحياناً أكثر إيجابية وثقة مما تسمح به خبرته في المجال',
      'قد يبدو أحياناً متسلطاً ومتحكماً',
      'قد يضغط أحياناً بشكل مفرط لإنجاز العمل',
      'قد يثير انزعاج الآخرين برغبته في إتمام جميع الأعمال فوراً',
    ],
    description:
      'The ENTJ is an honest, decisive individual. They are delivery focused and organized, with an eye for the big picture and long term strategic planning.  ENTJs are often very charismatic and can get people to follow their lead. They choose to be direct and purposeful in their interactions, avoiding getting too involved or close and personal. The ENTJ strives to be efficient, and is unlikely to give up at a task, striving to rise above each obstacle that gets in their way.',
    individualTypeByLetters: 'Executive',
    individualDescription:
      'As an Executive, they are likely to be an honest and decisive individual. They tend to be particularly delivery focused and organized, with an eye for the bigger picture and long term strategic planning. As an Executive, they are likely to be charismatic and able to get people to follow their lead; choosing to be direct and purposeful in their interactions, and avoiding getting too involved or close and personal. They are likely to strive to be efficient and are unlikely to give up at a task rising above any obstacles in their way.',
  },
  ENTP: {
    shortDescription: 'صاحب رؤية',
    atWorkParagraphs: {
      effectiveness: [
        'المساهمة بإبداعهم دون إغراق الآخرين بعدد كبير من الاحتمالات',
        'عدم توزيع طاقتهم على عدد كبير من المشاريع في نفس الوقت',
        'تطوير الانضباط الذاتي لديهم',
        'استخدام مهاراتهم التحليلية لتحديد الاتجاه الذي يرغبون في اتباعه',
        'العمل على تحسين مهارات اتخاذ القرار',
        'تذكير أنفسهم بأن تنفيذ الفكرة أكثر تعقيداً من تخيلها',
        'العمل على متابعة التزاماتهم عن طريق تدوين ما وعدوا به',
        'إتاحة الفرصة للآخرين لتولي الدور والتألق أكثر',
        'عدم تبسيط كل شيء إلى نموذج مفاهيمي',
        'الاهتمام بالمعلومات التي لا تنتمي إلى المجال المنطقي',
        'إعطاء الأولوية لبدائل أخرى مع التركيز بشكل أكبر على الأشخاص',
        'تقبّل أنهم قد لا يعرفون كل شيء',
        'تحسين تقنيات إدارة الوقت',
        'مراعاة الاحتياجات الشخصية لزملائهم بشكل أكبر',
        'التركيز أكثر على الجوانب العملية',
      ],
      teamLeader: [
        'يكون صاحب رؤية ويولّد أفكاراً جديدة بسهولة',
        'يحفّز الآخرين من خلال وضع معايير عالية',
        'يتوقع من الآخرين أن يتحدّوا أنفسهم فعلاً ويحققوا إنجازات جديدة بتجاوز المهام المطلوبة',
        'يُشرك أفضل الأشخاص ويُلهمهم للعمل معه',
        'يُدمج اهتمامات أعضاء الفريق في خطة عمل مشتركة',
        'يُتيح تفاعلاً ديناميكياً بين العملية والمحتوى',
        'يطرح الأسئلة وينتقد الاحتمالات المختلفة',
        'يقدّم وجهات نظر متنوعة بالإضافة إلى المعلومات لإيجاد الحل الأفضل والأكثر موضوعية',
      ],
      conflicts: [
        'من المحتمل أن ينزعج من الأشخاص الذين يرفضون النظر في احتمالات جديدة',
        'قد ينزعج من الأشخاص الذين لا يفهمون أن العملية والمحتوى مهمان بنفس القدر',
        'من المرجح أن ينزعج من الأشخاص غير القادرين على التمييز بين الأمور الجوهرية والتفاصيل التافهة',
        'قد يدخل في صراعات مع الأشخاص الذين يفتقرون إلى روح الإنجاز والموقف الإيجابي',
      ],
      stressAdvisor: [
        'يتحمل عدداً كبيراً من المشاريع التي لا يمكن إتمامها',
        'يتجنب التفاصيل ويصبح مضطرباً ومتوترًا',
        'ينتهي به الأمر بالانسحاب من الموقف ويكتشف أنه بحاجة إلى الكثير من الدعم',
      ],
      workEnvironment: [
        'يتضمن القليل من التكرار والروتين، مع العديد من الفرص للتفاعل والتعاون مع الآخرين',
        'يشمل الخيال والابتكار حيث تُناقش الأفكار وتُتبادل',
      ],
    },
    atWorkTagLine: '---',
    atWorkSneakPeek: 'إحدى الطرق التي يمكن أن يعزز بها %fname فعالية عمله هي بعدم تبديد طاقته على العديد من المشاريع في نفس الوقت',
    withOthersTagLine: '---',
    withOthersSneakPeek: 'قد يشعر %fname براحة أكبر عند تولي الأدوار التالية في فريقه: مولّد الأفكار، المنفذ، أو الناقد',
    withOthersParagraphs: {
      strengths: [
        'اجتماعي وودود',
        'رفيق ممتع، متنبه وصريح',
        'يطرح الأسئلة وسريع في التحدي',
        'يتمتع بطاقة عالية وروح دعابة',
        'حماسه معدي',
        'عفوي',
        'متعاطف وودود',
        'قد يجادل من باب المرح على أي جانب من السؤال',
        'يقدر الآخرين بناءً على ذكائهم وقدرتهم، وليس على أساس مكانتهم',
        'قادر على رؤية وجهات نظر مختلفة',
        'جيد في قراءة الآخرين',
        'مرن، متكيف ومنفتح',
        'سهل المعشر وغير رسمي',
        'غير ملتزم بالتقاليد، فردي',
      ],
      weakSpotsWithOthers: [
        'قد يبدو أحياناً غير حساس للقضايا العاطفية',
        'قد ينفر الآخرين بسبب ميله للنقاش والمجادلة الفكرية',
        'يحتاج إلى درجة عالية من الاستقلالية',
        'قد يربك الآخرين بانفجاراته من الأفكار',
      ],
    },
    typeTagLine: '--',
    typeSneakPeek: 'نوع %fname يُسمى ENTP. بعض الكلمات المرتبطة به هي صاحب رؤية، رائد أعمال، أو مهتم بالإنجاز',
    typeKeywords: [
      '1. منطقي',
      '2. بارع',
      '3. مفكر حر',
      '4. متحمس',
      '5. صاحب رؤية',
      '6. يبحث عن الاحتمالات',
      '7. شخص يرى الصورة الكبيرة',
      '8. ريادي',
      '9. خيالي',
      '10. متكيف',
      '11. كفء',
      '12. موجه نحو الإنجاز',
    ],
    typePersonalStrengths: [
      'سريع، منطقي، بارع وماهر في العديد من الأمور',
      'عقلية "إذا استطاع تخيله، يستطيع فعله"',
      'يحب حل المشكلات المعقدة والتعامل معها كتحديات',
      'متفوق في إدراك الأنماط ورؤية الصورة الكبرى',
      'متفوق في الكشف عن المبادئ الأساسية للمشكلة',
      'جيد في حل المشكلات بحلول طويلة المدى',
      'يتخيل إمكانيات الموقف ثم يحللها استراتيجياً لتحديد أفضل مسار للعمل',
      'غالباً ما يكون ماهراً في ملاحظة الاتجاهات والتنبؤ بالمستقبل',
      'يمتلك توجهًا عالياً نحو الإنجاز، ويستمتع بتحدي نفسه والآخرين',
      'جيد في تحفيز الآخرين من خلال وضع معايير عالية',
      'قادر على الارتجال والتكيف مع متطلبات اللحظة',
      'مدفوع بالإلهام',
      'مفكر مفاهيمي بطبيعته',
      'يميل إلى العمل بانفجارات من الطاقة والحماس',
      'قد يكون صاحب رؤية ديناميكي، ومخطط للمستقبل',
      'جيد في قيادة جهود التغيير',
      'فضول فكري عالي',
      'جيد في إجراء الملاحظات الموضوعية',
      'لا يؤمن بالقواعد وغالباً ما يتجاوزها لتحقيق هدفه',
      'موجه ذاتياً ومستقل عن السلطة',
      'قادر على العمل بشكل مستقل',
      'جيد في تطبيق المعرفة واستغلال المهارات',
      'مبتكر، مخطط ومصمم، ويستمتع بالتعقيد',
      'قوي في تطوير نظريات ونماذج وأفكار وأنظمة جديدة',
      'ماهر في صياغة الكلمات',
      'جيد في تحليل الأمور بالمنطق والتعاطف معاً',
      'مفكر أصلي',
      'قادر على الجدال بشكل جيد',
      'متفائل أبدي',
      'جيد في تشكيل وتوضيح الأفكار مع رؤى إبداعية جديدة',
      'جيد في تقديم التحليل والتركيب',
    ],
    typeWeakSpots: [
      'غير صبور ولديه قدرة تحمل منخفضة عندما تسير الأمور ببطء شديد',
      'يميل إلى تحمل العديد من المهام في نفس الوقت',
      'يشعر بالملل من الروتين والعمل غير التحدي، ونادراً ما يقوم بنفس الشيء بنفس الطريقة',
      'يقدّر الكفاءة والإنجاز عالياً، ويتوقع الكثير من الآخرين',
      'من المحتمل أن يضع معايير عالية لنفسه قد تؤدي إلى حالات من الشك الذاتي',
    ],
    description:
      'شخصية ENTP هي رائدة في التغيير والابتكار. مزدهرة بالمرونة والإبداع، فهي شخصية اجتماعية وتستمتع بمناقشة الأفكار والمفاهيم، وغالباً ما تلعب دور محامي الشيطان لجعل الآخرين يفكرون في طرق جديدة ومتنوعة للقيام بالأشياء. نشطة ومتحدثة، تسعى شخصية ENTP لاستكشاف بيئات جديدة للعثور على تحديات فكرية جديدة. لا تحب الرتابة. التكرار يدفعها لتوزيع جهودها بشكل مفرط أو القيام بالأشياء بطريقة مختلفة لتجنب الملل وإضافة التنوع والإثارة إلى المهمة.',
    individualTypeByLetters: 'صاحب رؤية',
    individualDescription:
      'بصفتهم صاحب رؤية، من المحتمل أن يكونوا رواداً في التغيير والابتكار. يزدهرون بالمرونة ويسعون للابتكار، وهم اجتماعيون ويستمتعون بمناقشات الأفكار والمفاهيم. قد يلعبون دور محامي الشيطان لجعل الآخرين يفكرون في طرق جديدة ومتنوعة للقيام بالأشياء. نشيطون ومتحدثون، ومن المرجح أن يسعوا لاستكشاف بيئات جديدة للعثور على تحديات فكرية جديدة. الخوف من الرتابة والتكرار يجعلهم معرضين لتوزيع جهودهم بشكل مفرط، ويحاولون القيام بالأشياء بطريقة مختلفة لتجنب الملل وإضافة التنوع والإثارة إلى المهمة.',
  },
  ESFJ: {
    shortDescription: 'مزوّد',
    atWorkParagraphs: {
      effectiveness: [
        'تذكير أنفسهم بأن يكونوا أكثر إيجازاً ومباشرة',
        'تعلم عدم أخذ النقد أو الرفض بشكل شخصي، مع الاعتراف بالحقائق الموضوعية الكامنة وراءه',
        'التصرف بشكل أقل سرعة نيابة عن الآخرين',
        'ترك الآخرين يرتكبون أخطاءهم بأنفسهم',
        'تذكير أنفسهم بعدم مناقشة القضية إلى ما لا نهاية، وترك الأمور التافهة بسهولة أكبر',
        'تقليل التركيز على التوافق الجماعي',
        'قبول أنه في بعض الأحيان من الضروري إعادة تقييم القرارات المتفق عليها في ضوء معلومات إضافية، حتى لو كان هذا يعني البدء من جديد',
        'قبول أن الخطط والعمليات ليست ثابتة',
        'أن يكون أكثر تقبلاً لحدس الآخرين',
        'قبول أن الغموض جزء من الحياة وأنه أحياناً يجب اتخاذ القرارات في ظل عدم اليقين',
      ],
      teamLeader: [
        'وضع جدول أعمال واضح وتحقيق التوافق والإنهاء من خلال احترام الالتزامات الزمنية',
        'خلق جو يفهم فيه الجميع أهميتهم للفريق ويشعرون بالتشجيع على المساهمة',
        'العمل بشكل تعاوني لتحديد ما يجب القيام به، ومن هو الأنسب للقيام بهذه المهام',
        'تحفيز الآخرين باستخدام حجج مقنعة تأخذ مشاعر الناس بعين الاعتبار',
        'التركيز على طرق عملية لجمع الفريق معاً في حل المشكلات',
        'توضيح القضايا المفتوحة من خلال طرح الأسئلة الصحيحة بدلاً من تقديم كل الإجابات بأنفسهم',
      ],
      conflicts: [
        'قد يواجه صراعات مع الأشخاص الذين يعتبرهم سلبيين',
        'من المرجح أن يدخل في صراعات مع الأشخاص الذين يعتقد أنهم لا يتحملون مسؤولية حل المشكلات',
        'قد ينزعج من الأشخاص الذين يرفضون الالتزام بالجدول المحدد ويضيعون الوقت',
        'قد ينزعج من الأشخاص الذين يفسدون التوافق من خلال لعب دور محامي الشيطان',
        'من المحتمل أن تكون لديه قدرة تحمل منخفضة تجاه الأشخاص الذين يبطئون التقدم من خلال مقاطعة سير العمل باستمرار',
        'من المرجح أن يدخل في صراعات مع الأشخاص الذين لا يُكملون المهام بدقة وفي الوقت المحدد',
      ],
      stressAdvisor: [],
      workEnvironment: [],
    },
    atWorkTagLine: '---',
    atWorkSneakPeek: 'إحدى الطرق التي يمكنهم من خلالها تعزيز فعالية عملهم هي السماح للآخرين بارتكاب أخطائهم بأنفسهم',
    withOthersTagLine: '---',
    withOthersSneakPeek: 'قد يشعرون براحة أكبر عند تولي الأدوار التالية في فريقهم: المنظم، المنفذ، أو الدقيق',
    withOthersParagraphs: {
      strengths: [
        'دافئ القلب، ودود وداعم',
        'ثرثار، محبوب',
        'مراعي',
        'منسجم',
        'يميل إلى امتلاك حس قوي بالمسؤولية الاجتماعية، وإيثاري',
        'محترم، مهذب',
        'شخصية متعاطفة تتخذ القرارات بناءً على القيم',
        'متأمل',
        'حس قوي بالواجب',
        'وفي للأصدقاء والزملاء',
        'يقدّر التقاليد',
      ],
      weakSpotsWithOthers: [
        'يميل إلى أخذ النقد الموضوعي بشكل شخصي',
        'يكره النزاع بشدة، ويتجنب الصراع',
        'يبحث بشكل خاص عن التقدير',
        'قد يكون صارماً جداً، ولا يتكيف بسهولة مع التغيير',
        'يتخيل الإساءات حيث لا توجد نية لذلك',
      ],
    },
    typeTagLine: '--',
    typeSneakPeek: 'نوع %fname يُسمى ESFJ. بعض الكلمات المرتبطة به هي متناسق، متعاطف، أو منظم',
    typeKeywords: [
      '1. الانسجام',
      '2. دافئ',
      '3. منظم',
      '4. متعاون',
      '5. مراعي',
      '6. دقيق',
      '7. متعاطف',
      '8. ملتزم بالواجب',
      '9. عملي',
      '10. منهجي ومنظم',
      '11. يخطط',
    ],
    typePersonalStrengths: [
      'موقف إيجابي ومتفائل',
      'تقديم الراحة',
      'جيد في تهدئة النزاعات',
      'وفي للأنظمة القائمة وماهر في الحفاظ على التقاليد',
      'يأخذ العمل على محمل الجد ويعتقد أن الآخرين يجب أن يفعلوا كذلك',
      'ضميري ويمتلك انتباهاً ممتازاً للتفاصيل',
      'يضيف جواً من الدفء لكل ما يفعله',
      'من المرجح جداً أن يتابع الأمور حتى في الأمور الصغيرة',
      'منتبه، يلاحظ ما يحتاجه الآخرون في حياتهم اليومية ويحاول توفيره',
      'لاعب فريق ممتاز، متعاون',
      'جيد في خلق بيئة متناغمة',
      'جيد في تنظيم العالم من حوله',
      'قادر على إنجاز الأمور في الوقت المحدد وبالمستوى المطلوب',
      'واقعي، يعتمد على الحقائق',
      'جيد في تحديد طرق العمل الجماعي الموجهة نحو الأهداف',
      'نهج مسؤول تجاه العمل، قادر على إيجاد طريقة ليكون مفيداً',
      'جيد في التخطيط بالتفصيل',
      'جيد في تقديم منظور منهجي وعملي',
      'جيد في تنظيم وتحفيز الأشخاص للمساهمة',
      'جيد في الشمولية والاعتراف بآراء الآخرين المختلفة',
      'يضيف الانسجام للفريق من خلال التنظيم الدقيق والحماس وروح الدعابة',
      'مهتم بشدة بالأشياء التي تؤثر مباشرة ومرئياً على حياة الناس',
      'يمتلك توجه قوي لخدمة العملاء، ويحب أن يشعر الناس بالتقدير',
    ],
    typeWeakSpots: [
      'رغبة قوية في الانسجام، يميل إلى تجنب النزاعات قدر الإمكان',
      'يعمل بشكل أفضل مع التشجيع والثناء، وقد يتراجع إذا لم يتلقاه',
      'قلة الاهتمام بالمفاهيم المجردة التي لا تكون لها آثار مباشرة على الناس',
      'يحتاج إلى بيئة عمل منظمة',
      'يميل إلى كراهية التغيير وعدم الاستقرار والأزمات',
      'يدعم النظام القائم وقد يكون معتمداً بشكل مفرط على السلطة. يأخذ النظام والقواعد القائمة كأمر مفروغ منه',
      'يتوق إلى شعور بالانتماء. قد يشعر بخيبة أمل ويصبح غير متحفز إذا لم يُقدَّر على من هو وما يقدمه',
      'قد يبالغ في تقدير مكانته ورتبته مقارنة بالكفاءة التقنية',
      'يحتاج إلى دور محدد بوضوح في الفريق وأهداف محددة بوضوح',
      'قد يُفسر التركيز على التفاصيل على أنه نقص في الخيال من قبل بعض الزملاء',
    ],
    description:
      'شخصية ESFJ هي شخصية عطوفة، تركز على دعم الآخرين وخلق الانسجام. يتميز الـ ESFJ بالضمير والاهتمام بالعلاقات، ويرى الإيجابيات في الناس. مخلص للغاية وملتزم تجاه فريقه، يركز على الإنجاز ومستعد لتقديم المساعدة للآخرين. يحب الـ ESFJ الحفاظ على الانسجام داخل الفريق دون التضحية بإنجاز الأمور، من خلال البحث عن حلول ترضي الجميع.',
    individualTypeByLetters: 'مزوّد',
    individualDescription:
      'بصفته مزوّداً، من المرجح أن يكون شخصاً عطوفاً يركز على دعم الآخرين وخلق الانسجام. من المحتمل أن يكون ضميريًا ومهتمًا بالعلاقات، ويرى الإيجابيات في الناس. يميل إلى أن يكون مخلصاً للغاية وملتزماً تجاه فريقه، مركزاً على الإنجاز ومستعداً لمساعدة الآخرين. بصفتهم مزوّداً، من المحتمل أن يحافظوا على الانسجام داخل الفريق دون التضحية بإنجاز الأمور، من خلال البحث عن حلول ترضي الجميع.',
  },
  ESFP: {
    shortDescription: 'المؤدي',
    atWorkParagraphs: {
      effectiveness: [
        'الابتعاد عن التركيز على الحاضر نحو نهج أكثر تركيزاً على المهام',
        'تطوير تقدير أفضل للتفكير في الصورة الكبيرة',
        'الحصول على التوازن الصحيح بين الحيوية والمرح المفرط',
        'التعبير عن آرائهم الخاصة بشكل أكثر حزمًا',
        'التأكيد على اعتبارات المهام',
        'أن يكونوا أكثر حزمًا وقول "لا" للمطالب غير المعقولة',
        'التركيز على المتطلبات التفصيلية للمهام',
        'عدم أخذ النقد بشكل شخصي',
        'الاعتراف بقيمة التحليل المنطقي',
      ],
      teamLeader: [
        'حاول أكثر لبدء العملية بالكامل وتلخيص القرارات التي تم اتخاذها',
        'تشجيع التعاون بين أعضاء الفريق وضمان تقدير نقاط القوة ومساهمات الجميع',
        'تشجيع المشاركة الواسعة والتأكد من أخذ جميع الآراء والاقتراحات بعين الاعتبار قبل اتخاذ القرار',
        'تشجيع الآخرين على تحقيق نتائج إيجابية',
      ],
      conflicts: [
        'قد يشعر بالإحباط من الأشخاص الذين يراهم سلبيين للغاية، نقديين، يلقون اللوم ومتشائمين',
        'قد ينزعج من الأشخاص الذين يتحدثون بطريقة متعالية دون الوصول إلى النقطة الأساسية',
        'قد ينزعج من الأشخاص الذين يركزون فقط على المهمة ويصبحون غير حساسين تجاه الأشخاص المحيطين (الحقيقيين وليس الضروريين)',
        'يميل إلى صعوبة العمل مع الأشخاص ذوي الرؤية المحدودة الذين لا يقدّرون وجهات النظر والمساهمات المختلفة',
      ],
      stressAdvisor: [],
      workEnvironment: ['تطبيقي', 'عملي', 'منشط وممتع', 'يوفر الحرية والمساحة', 'غير روتيني'],
      underSevereStress: [
        'قد يُنظر إليهم على أنهم متساهلون للغاية، يأخذون الأمور بشكل شخصي أكثر من اللازم ولا يولون اهتماماً كافياً للتفاصيل أو النظرية أو الصورة الكبيرة',
      ],
      weakSpotsWithOthers: ['تحت ضغط شديد، قد يجدون صعوبة في الانسحاب من مشروع لتلبية الاحتياجات العملية أو البدنية'],
    },
    atWorkTagLine: '---',
    atWorkSneakPeek: 'إحدى الطرق التي يمكنهم من خلالها تعزيز فعالية عملهم هي تطوير تقدير أفضل للتفكير في "الصورة الكبيرة"',
    withOthersTagLine: '---',
    withOthersSneakPeek: 'قد يشعرون براحة أكبر عند تولي الأدوار التالية في فريقهم: المنفذ، الوسيط، أو المبتكر بين الحدود',
    withOthersParagraphs: {
      strengths: [
        'منفتح',
        'دافئ',
        'ودود',
        'داعم',
        'محب للمرح',
        'عفوي',
        'متسامح',
        'منفتح العقل',
        'مليء بالحيوية',
        'ثرثار',
        'متعاطف',
        'لبق',
        'متعاون',
        'مساوٍ للآخرين',
        'سهل المعشر',
        'حساس لاحتياجات الآخرين',
      ],
      weakSpotsWithOthers: [
        'أحياناً متساهل للغاية',
        'أحياناً عاطفي بشكل مبالغ فيه',
        'قد يُنظر إليه على أنه قليل التنظيم',
        'قد يأخذ النقد بشكل شخصي للغاية',
        'قد يبالغ في تفسير الموقف',
        'قد يحاول القيام بالعديد من الأمور في نفس الوقت',
      ],
    },
    typeTagLine: '--',
    typeSneakPeek: 'نوع %fname يُسمى ESFP. بعض الكلمات المرتبطة به هي نشيط، يحب التجربة، أو واقعي',
    typeKeywords: [
      '1. متحمس',
      '2. متفائل',
      '3. موجه نحو العمل',
      '4. نشيط',
      '5. عملي',
      '6. متسامح',
      '7. عاطفي',
      '8. واقعي',
      '9. عملي/على الأرض',
      '10. أنشطة جديدة، أشخاص جدد',
      '11. تجربة',
      '12. قابل للتكيف',
    ],
    typePersonalStrengths: [
      'مستوى عالٍ من الطاقة',
      'إيجاد حلول عملية لمشكلات العالم الواقعي',
      'تطوير حلول تأخذ احتياجات ومشاعر الآخرين بعين الاعتبار',
      'متعاطف ويفهم الناس، مستعد لأخذ وجهات نظر الآخرين في الاعتبار',
      'لا يلتزم بالطرق القديمة، ولكنه مستعد للتكيف',
      'موجه نحو الهدف ومستعد للسير على الطريق المباشر نحو النجاح بدلاً من إضاعة الوقت والجهد غير الضروري',
      'مستعد ومتحمس لإنجاز الأمور',
      'يحب العمل وجعل الأشياء تحدث',
      'يعرف ما يحدث وينضم بحماس',
      'يضيف الحس العملي والمنهج الواقعي لحل المشكلات',
      'جيد في تذكر الحقائق',
      'جيد في الاستجابة للأزمات',
      'جيد في تهدئة النزاعات',
      'جيد في الشمولية',
      'ينشط الآخرين بالتفكير الإيجابي',
    ],
    typeWeakSpots: [
      'قد يُنظر إليه على أنه يتبع أسلوباً شخصياً للغاية',
      'قد يبدو أنه لا يأخذ الأمور بجدية كافية',
      'قد يزعج الآخرين بتجاهل النقاشات المجردة والمفاهيمية',
      'يميل إلى تجنب النزاع',
      'يميل إلى كراهية الروتين ويجد صعوبة في الالتزام بالإجراءات والأنظمة المحددة',
      'من المحتمل ألا يقضي وقتاً كافياً في إتقان النظريات، ويفضل الغوص مباشرة في العمل',
      'الانتباه المستمر للتفاصيل الدقيقة ليس شيئاً طبيعياً بالنسبة لهم',
    ],
    description:
      'يميل ESFP للاستمتاع بالأشياء الجمالية والمرئية. من المحتمل أن يكونوا جذابين ومتفائلين، ويشجعون الآخرين، مع حساسية خاصة لاحتياجاتهم. ودودون وعمليون، ويعتبر التعاون والانسجام أمراً مهماً بالنسبة لهم، حيث يستمتعون بالأنشطة العملية ويفضلون الحركة والنشاط للحفاظ على اهتمامهم ومشاركتهم. من خلال جلب الأمل والتفاؤل وروح "يمكن فعلها"، من المحتمل أن يضيف ESFP جوًا تعاونيًا وشخصيًا للمواقف، مع الهدف والعمل.',
    individualTypeByLetters: 'المؤدي',
    individualDescription:
      'بصفتهم مؤديًا، يميلون للاستمتاع بالأشياء الجمالية والمرئية. من المحتمل أن يكونوا جذابين ومتفائلين ويشجعون الآخرين، مع حساسية خاصة لاحتياجاتهم. كونهم ودودين وعمليين، فإن التعاون والانسجام مهم بالنسبة لهم، حيث يميلون إلى الاستمتاع بالأنشطة العملية ويفضلون الحركة والنشاط للحفاظ على اهتمامهم ومشاركتهم. من خلال جلب الأمل والتفاؤل وروح "يمكن فعلها"، من المحتمل أن يضيفوا جوًا تعاونيًا وشخصيًا للمواقف، مع الهدف والعمل.',
  },
  ESTJ: {
    shortDescription: 'الحامي',
    atWorkParagraphs: {
      effectiveness: [
        'أصبحوا أكثر حساسية لاحتياجات الناس',
        'النظر أبعد من الحقائق نحو الصورة الكبيرة',
        'الاستماع أكثر للآخرين وإعطاء الآراء المعارضة وزنًا أكبر',
        'التأكد من جمع معلومات كافية قبل الإسراع في الإنجاز',
        'تفويض المهام أكثر والسماح للآخرين بتطوير مهارات القيادة لديهم',
        'فهم أن العملية مهمة لتحقيق منتج جيد وتعلم كيفية التحرك أسرع من خطوة واحدة في كل مرة',
        'أن يكونوا أكثر انفتاحًا على وجهات النظر البديلة حتى لو بدت غير منطقية في البداية',
        'التأكيد على الاعتبارات الشخصية بالإضافة إلى المهام',
        'إتاحة مساحة كافية للآخرين ليكونوا مبتكرين ويعززوا الإبداع',
        'تطوير حسهم باللباقة والدبلوماسية',
        'أن يكونوا أكثر انفتاحًا على التجربة',
        'إيقاف الحكم النقدي أثناء جلسات العصف الذهني',
        'زيادة قدرتهم على تحمل عدم اليقين',
      ],
      teamLeader: [
        'كون جيدًا في تقديم التوجيه',
        'كن حازمًا في تنفيذ الخطط',
        'كون جيدًا في إدارة السلوك وفق مبادئ صارمة',
        'تطوير خطط مفصلة وموجهة نحو النتائج',
        'كون جيدًا في تحديد وتوضيح القضايا',
        'تحديد مهمة ومسؤولية واضحة لكل عضو في الفريق',
        'تحدي الفريق باستمرار لتقديم أفضل ما لديهم',
        'كون جيدًا في التأكد من التزام الناس بالقواعد والسياسات',
        'إظهار طاقة عالية والتزام',
        'كون جيدًا في إنجاز الأمور',
      ],
      conflicts: [
        'من المرجح أن ينزعج من أعضاء الفريق الذين يفتقرون للتركيز، ويبتعدون عن المهمة ويضيعون الوقت',
        'قد ينزعج من أعضاء الفريق غير المستعدين والذين لا يتابعون المهام',
        'من المرجح أن يشعر بالإحباط من الاجتماعات التي يراها تفتقر إلى أهداف واضحة أو جدول أعمال أو تنظيم',
        'قد يشعر بعدم الرضا عند العمل في دور يفتقر إلى تعريف واضح وأهداف محددة',
        'قد يصطدم بأعضاء الفريق المتأخرين أو الغائبين أو الحاضرين دون المشاركة الفعالة',
      ],
      underStress: [
        'تحت الضغط: قد يصبح ناقدًا مفرطًا لنفسه وللآخرين',
        'قد يشعر بعدم التقدير أو يسمع التعليقات البريئة على أنها هجمات شخصية',
        'تحت ضغط شديد: قد يصبح ESTJs غاضبين ومسَيْطرين، يصدرون التعليمات دون التفكير بعواقبها على الآخرين',
      ],
      stressAdvisor: [
        'تحت الضغط: قد يصبح ناقدًا مفرطًا لنفسه وللآخرين',
        'قد يشعر بعدم التقدير أو يسمع التعليقات البريئة على أنها هجمات شخصية',
        'تحت ضغط شديد: قد يصبح ESTJs غاضبين ومسَيْطرين، يصدرون التعليمات دون التفكير بعواقبها على الآخرين',
      ],
      workEnvironment: [
        'إتاحة التركيز على التفاصيل والخطط، حيث تكون المسؤوليات محددة بوضوح',
        'حيث يتواجد الناس كثيرًا، مع فرص لتولي القيادة',
      ],
    },
    atWorkTagLine: '---',
    atWorkSneakPeek: 'إحدى الطرق التي يمكنهم من خلالها تعزيز فعالية عملهم هي أن يصبحوا أكثر حساسية لاحتياجات الآخرين الشخصية والاجتماعية.',
    withOthersTagLine: '---',
    withOthersSneakPeek: 'قد يشعر %fname براحة أكبر عند تولي الأدوار التالية في فريقه: المنفذ، المنظم، أو الدقيق/المحافظ على التفاصيل',
    withOthersParagraphs: {
      strengths: [
        'اجتماعي، نشيط ومنفتح',
        'واثق من نفسه ومطمئن',
        'سريع في التعبير عن آرائه الخاصة',
        'صريح، مباشر، وبأسلوب عملي',
        'مسؤول وملتزم',
        'يقدر الكفاءة والفعالية لدى الآخرين',
        'ينتقد الآخرين بصراحة إذا لم يلبوا معاييره الشخصية',
        'مستعد للإشراف على الآخرين لضمان تنفيذ النظام العملي الطبيعي للأشياء',
        'مبادر في تكوين علاقات اجتماعية جديدة',
        'عقل متين وحازم',
        'مرتاح في إصدار التوجيهات',
      ],
      weakSpotsWithOthers: [
        'قد لا يأتي فهم مشاعر الآخرين بشكل طبيعي',
        'قد يُنظر إليه على أنه صريح جدًا',
        'قد يبدو مسيطرًا للغاية، مع ميل لاتخاذ قرارات للآخرين دون استئذانهم أولاً',
        'الرغبة القوية في التأكد قد تجعل من الصعب قبول وجهات نظر وملاحظات مختلفة',
        'قد يُعتبر من قبل الآخرين استبداديًا',
        'ميل لاتخاذ القرارات بسرعة دون جمع معلومات كافية',
        'قد يبدو أنه يتخذ القرارات لمجرد إنهاء الأمور',
        'قد يبدو غير مرن',
        'قد يغفل عن الجانب البشري في إنجاز الأمور',
        'قد يُنظر إليه على أنه ناقد ومتعجل للغاية',
        'قد لا يكون شاملاً بما فيه الكفاية',
        'التركيز على التفاصيل والجانب العملي قد يجعل الآخرين يرونه قليل الخيال',
      ],
    },
    typeTagLine: '--',
    typeSneakPeek: 'نوع %fname يُسمى ESTJ. بعض الكلمات المرتبطة به هي حاسم، منطقي، أو إداري',
    typeKeywords: [
      '1. حاسم',
      '2. ذو عقل متين',
      '3. منظم',
      '4. دقيق',
      '5. مسؤول',
      '6. إجراءات',
      '7. منطقي',
      '8. إداري',
      '9. مرتب',
      '10. قائم على الحقائق',
      '11. تحليلي',
      '12. مبدئي',
    ],
    typePersonalStrengths: [
      'جيد في التحليل وجلب النظام إلى العالم',
      'جيد في تنظيم المشاريع والأشخاص',
      'ضميري ويعمل بنشاط لإكمال المهام',
      'يركز بقوة على الحصول على نتائج فورية ومرئية بأكثر الطرق كفاءة ممكنة',
      'نهج عملي وواقعي وعملي',
      'يتعامل مع المشكلات والآخرين بطريقة مباشرة وعملية',
      'تفكير منطقي قوي',
      'أخلاقيات عمل قوية',
      'جيد في العناية بالتفاصيل الروتينية',
      'قوي في التخطيط',
      'حاسم وسريع في تنفيذ القرارات',
      'جيد في توثيق الإجراءات والمعلومات',
      'اهتمام ممتاز بالتفاصيل وجيد في اكتشاف وتصحيح الأخطاء',
      'جيد في تحسين الأمور من خلال خطوات صغيرة',
      'يحب تولي المسؤولية',
      'حافظ جيد للتقاليد، مخلص للنظام والهياكل القائمة',
      'موثوق، يأخذ المسؤوليات على محمل الجد',
      'جيد في تجميع الأشياء',
      'جيد في فرض القواعد والسياسات',
      'وجهة نظر واقعية، مع تركيز واضح على ما يجب القيام به بعد ذلك',
      'عادةً لديه مجموعة واضحة من المعايير المنطقية ويتبعها بشكل منهجي',
      'جيد في التحذير من المخاطر',
      'نهج منهجي ومنظم',
    ],
    typeWeakSpots: [
      'تحمل منخفض لعدم اليقين، يفضل أن يكون متأكدًا من قناعاته حتى لو كان خاطئًا بدلاً من التعامل مع عدم اليقين',
      'متردد في تغيير الهياكل والتقاليد القائمة. قد يقدر الاستقرار على الابتكار',
      'قد يكون مركزًا جدًا على الأمور الفورية ويتجاهل العواقب طويلة المدى',
      'غير مرن تجاه تغييرات الخطة',
      'التركيز القوي على التفاصيل قد يحد من القدرة على التفكير في الصورة الكبيرة',
      'قد يحد من إبداعه وإبداع الآخرين عن طريق رفض الأفكار التي لا تستخدم على الفور',
      'قد يبالغ في تقدير أهمية التسلسل الهرمي، السلطة الرسمية والقوة',
      'قد ينسى مراعاة مشاعر الآخرين ووجهات نظرهم في اتخاذ القرارات',
      'أحيانًا مفرط في الحذر',
    ],
    description:
      'من المرجح أن يكون ESTJ نشيطًا ومركزًا على الإنجاز. على الرغم من أنه ليس بالضرورة مرنًا جدًا، إلا أن ESTJ يميل إلى تفضيل التخطيط والهدف، ويكون سعيدًا بتولي زمام الأمور. يعتمد ESTJ على الطرق المجربة والمعلومات الواقعية والعمليات المنهجية. كنوع منفتح، من المحتمل أن يكون سعيدًا بأن يكون محور الاهتمام، مناقشًا أفكاره ومفاهيمه. يعمل بشكل أفضل عند وجود توجيه وخطة واضحة، وقادر على خلق النظام من الفوضى.',
    individualTypeByLetters: 'الحامي',
    individualDescription:
      'بصفتهم حاميًا، من المرجح أن يكونوا نشيطين ومركزين على الإنجاز. على الرغم من أنهم ليسوا بالضرورة مرنين بشكل خاص، إلا أنهم يميلون إلى تفضيل التخطيط والهدف، وعادة ما يكونون سعداء بتولي زمام الأمور. كحامي، يعتمدون عادةً على الطرق المجربة والمعلومات الواقعية والعمليات المنهجية. كنوع منفتح، من المحتمل أن يكونوا سعداء بأن يكونوا محور الاهتمام، مناقشين أفكارهم ومفاهيمهم. عند العمل بتوجيه وخطة واضحة، من المرجح أن يكونوا قادرين على خلق النظام من الفوضى.',
  },
  ESTP: {
    shortDescription: 'المنفذ',
    atWorkParagraphs: {
      effectiveness: [
        'البناء على قوتهم في عرض الحقائق واتخاذ وجهة نظر واقعية',
        'الاعتماد أقل على الارتجال (على الرغم من أنهم بارعون فيه) وأكثر على التحضير',
        'أخذ المزيد من الوقت قبل التصرف',
        'استخدام حسهم الفكاهي الجيد، مع الانتباه للتأثير السلبي للملاحظات الساخرة على الآخرين',
        'السعي لتجنب الأزمات، على الرغم من أنهم سرًا يحبون الحماس الذي تمنحه',
        'الاستعداد للتسوية عند الضرورة لتحريك الفريق',
        'ممارسة مهارات الاستماع لديهم',
        'قبول وتشجيع الابتكار لدى الآخرين',
        'إعطاء المزيد من الاهتمام لاحتياجات الزملاء الشخصية والاجتماعية',
      ],
      teamLeader: [
        'تقديم توجيه واضح وهدف لفريقهم',
        'توضيح المشكلة، جمع الآراء، مناقشة البدائل واتخاذ قرار عملي وفعال',
        'جعل الفريق يعمل معًا بأكثر الطرق فعالية',
        'تحفيز أفراد الفريق على العمل',
        'التكيف بسرعة مع التغيرات في البيئة وتعزيز أو تعديل استراتيجيتهم',
        'عدم الحكم على اقتراحات الآخرين طالما كانت منطقية',
      ],
      conflicts: [
        'قد ينزعجون من أعضاء الفريق الذين يرونهم سلبيين وغير ملتزمين',
        'قد تكون لديهم قدرة تحمل منخفضة تجاه الأشخاص الذين يرونهم غير مركزين وغير واقعيين',
        'من المرجح أن يواجهوا مشاكل مع أعضاء الفريق الذين لا يرون الطريق المنطقي وينشغلون بأهداف جانبية بلا عائد فوري',
        'من المرجح أن ينزعجوا من الأشخاص الذين يشتكون ويئنون ويقللون من الأمور كثيرًا',
        'قد ينزعجون من الذين يفتقرون لحس الفكاهة',
      ],
      stressAdvisor: [
        'يقاومون القواعد بشكل متزايد ويصبحون تنافسيين',
        'يتولون الكثير من المشاريع ويصبحون مرتجلين وحتى متهورين',
        'التفكير قبل الكلام، وإلا فقد يظهرون وكأنهم صارمون وغير مبالين',
      ],
      workEnvironment: ['يفضلون فرصًا للمرونة وتبادل الأفكار', 'يكرهون أن يكونوا مقيدين بالعديد من القواعد واللوائح'],
    },
    atWorkTagLine: '---',
    atWorkSneakPeek: 'إحدى الطرق التي يمكن لـ %fname من خلالها تعزيز فعالية عمله هي التحرك بخطى أكثر سلاسة نحو التنفيذ',
    withOthersTagLine: '---',
    withOthersSneakPeek: 'قد يشعر %fname براحة أكبر عند تولي الأدوار التالية في فريقه: الموزع للحدود، الصانع، أو الوسيط',
    withOthersParagraphs: {
      strengths: [
        'اجتماعي ومنفتح',
        'مرتجل ومتحمس',
        'متفتح ومتسامح',
        'حس فكاهي جيد',
        'مقدَّر لواقعيته وعمليته',
        'متحمس',
        'مغامر ويحب المرح',
        'حازم',
      ],
      weakSpotsWithOthers: [
        'قد يجرح الآخرين دون قصد عند التعبير عن آرائه بصراحة',
        'غالبًا ما يكون حريصًا جدًا على التخلي عن الأنظمة التي توفر للآخرين الاستقرار',
        'قد يكون غير صبور مع الأبعاد الشخصية لمهمة ما',
      ],
    },
    typeTagLine: '--',
    typeSneakPeek: 'نوع %fname يسمى ESTP. بعض الكلمات المرتبطة هي منطقي، مركز على الحقائق، أو قابل للتكيف',
    typeKeywords: [
      '1. مرتجل',
      '2. متفتح الذهن',
      '3. موجه نحو العمل',
      '4. منطقي',
      '5. عملي',
      '6. مرتجل/مبتكر',
      '7. محلل المشكلات',
      '8. مغامر',
      '9. نشيط',
      '10. فكاهي',
      '11. قابل للتكيف',
      '12. قائم على الحقائق',
    ],
    typePersonalStrengths: [
      'جيد في حل المشكلات العملية على الفور',
      'محلل مشكلات بطبيعته وماهر في إزالة العقبات وحل الصعوبات',
      'موقف إيجابي وعزيمة متحمسة للنجاح',
      'جيد في حالات الأزمات',
      'قابل للتكيف، متسامح ومرن',
      'موجه نحو العمل بشدة وماهر في تحفيز الآخرين على العمل',
      'واقعي وعملي',
      'جيد في تحليل واتخاذ القرارات المنطقية',
      'ماهر في التعامل مع الأشياء الملموسة التي يمكن العمل عليها أو التعامل معها أو تفكيكها أو تركيبها',
      'سريع في تكوين علاقات جديدة',
      'جاهز لتجاوز الأنظمة والبروتوكولات القائمة بحثًا عن حلول',
    ],
    typeWeakSpots: [
      'يميل إلى عدم حب الشروحات الطويلة والنظرية',
      'يشعر بالملل من الاستقرار المفرط',
      'يميل إلى الانطلاق في العمل بسرعة كبيرة',
      'يجد صعوبة في الاهتمام بالتفاصيل الدقيقة للمهمة',
      'يفضل التعلم من خلال التجربة العملية بدلاً من الدراسة الخاصة أو التأمل',
    ],
    description:
      'من المرجح أن يكون ESTP محبًا قويًا للعمل ويستمتع ببيئة سريعة الإيقاع. من المحتمل أن يكون شخصًا متحمسًا، يظهر ساحرًا ومباشرًا. يميل ESTP إلى التركيز أكثر على الأنشطة العملية والتخطيط، على الرغم من أنه يستمتع بالتنوع والتحديات والمرونة التي توفرها هذه الأمور، إلا أنه يجد صعوبة في التعامل مع المهام المملة والمتكررة. يحتاج ESTP إلى الحذر من محاولة القيام بالعديد من الأشياء في وقت واحد والمخاطرة بشكل كبير، حيث يمكن أن يؤدي ذلك إلى خلق الفوضى. من المرجح أن يضع العقلانية والتفكير قبل مشاعر الآخرين، مفضلًا التعامل مع التفاصيل الملموسة والمحددة.',
    individualTypeByLetters: 'فعل',
    individualDescription:
      'كشخص من نوع "فعل"، من المرجح أن يكون لديهم حب قوي للعمل ويستمتعون ببيئة سريعة الإيقاع. من المحتمل أن يكونوا أفرادًا متحمسين يظهرون ساحرين ومباشرين. يميلون إلى التركيز أكثر على الأنشطة العملية والتخطيط، مستمتعين بالتنوع والتحديات والمرونة التي توفرها هذه الأمور، لكنهم يجدون صعوبة في التعامل مع المهام المملة والمتكررة. كأشخاص من نوع "فعل"، يحتاجون إلى الحذر عند محاولة القيام بالعديد من الأشياء في وقت واحد والمخاطرة بشكل كبير، حيث يمكن أن يؤدي ذلك إلى خلق الفوضى. من المرجح أن يضعوا العقلانية والتفكير قبل مشاعر الآخرين، مفضلين التعامل مع التفاصيل الملموسة والمحددة.',
  },
  INFJ: {
    shortDescription: 'الحامي',
    atWorkParagraphs: {
      effectiveness: [
        'التعبير عن الأفكار والمشاعر والقيم الشخصية بحرية أكبر',
        'عدم التمسك بالفكرة بعناد شديد',
        'تطوير مهارات التواصل وبناء صداقات غير رسمية',
        'الاعتراف بأهمية الحديث القصير',
        'التأكد من عدم تجاهل الحاضر بسبب التركيز الشديد على الاحتمالات المستقبلية',
        'تعلم كيفية تقديم أنفسهم بشكل أفضل',
        'ممارسة تقنيات الحزم والثقة بالنفس',
        'تذكير أنفسهم بأن الناس أكثر احتمالاً لتطبيق فكرة عندما يُمنحون فرصة لإبداء الرأي',
        'الاعتراف بأهمية عدم الانسحاب من الآخرين في أوقات الضغط',
        'عدم وضع معايير غير قابلة للتحقيق لأنفسهم أو للآخرين',
      ],
      teamLeader: [
        'رؤية الصورة الكبيرة وتطوير الرؤية',
        'التعامل مع أعضاء الفريق بشكل فردي وتوقع أن ينجز كل عضو المهام الموكلة إليه',
        'تحفيز الفريق بأفكار إبداعية وحدسية',
        'التسوية مع الأغلبية، ما لم يكن هناك تعارض مع القيم الشخصية',
        'إدارة الصراعات الشخصية داخل المجموعات بنجاح',
        'تقييم ديناميكيات المجموعة وتقديم ملخصات شاملة وعميقة حول كيفية المضي قدماً',
        'إغلاق الاجتماعات بنجاح',
      ],
      conflicts: [
        'من المرجح أن يشعر بالإحباط من الأشخاص الذين يعتبرهم عدائيين أو غير صبورين أو متشائمين أو الذين لا يقدّرون الآخرين',
        'من المحتمل أن يواجه مشاكل مع الأشخاص الذين يقدمون نصائح غير مناسبة أو مبكرة، وغير راغبين في النظر في الأمور بعمق',
        'قد ينزعج من الأشخاص الذين يتحدثون كثيراً',
        'قد يزعجه الأشخاص الذين لا يساهمون في العمل المطلوب',
        'من المحتمل أن يتعارض مع الأشخاص الذين يركزون فقط على المحتوى ولا يولون أي اهتمام للعملية',
      ],
      stressAdvisor: [
        'قد يصبح متعاوناً بشكل مفرط، ويشعر بالحاجة لإرضاء الآخرين في كل فرصة',
        'يجد صعوبة في التعامل مع النقد',
        'يشعر بالحاجة لحل المشكلات بمفرده',
      ],
      workEnvironment: ['حيث توجد فرص للعمل على الصورة الكبيرة، والإبداع، مع إمكانية التمتع بالمرونة', 'حيث توجد مهام وجداول أقل روتينية'],
    },
    atWorkTagLine: '---',
    atWorkSneakPeek: 'إحدى الطرق لتعزيز فعالية عملك هي بعدم التمسك بالأفكار بعناد شديد',
    withOthersTagLine: '---',
    withOthersSneakPeek: '%fname قد يشعر براحة أكبر عند تولي الأدوار التالية في الفريق: المنظم الدقيق، مبتكر الأفكار، الوسيط',
    withOthersParagraphs: {
      strengths: [
        'هادئ، ودود واجتماعي',
        'يقدر الأشخاص والعلاقات في حياته بشكل كبير',
        'متعاطف',
        'قوي بهدوء',
        'عاطفي وعميق',
        'من غير المحتمل أن ينفتح على الناس حتى يعرفهم جيدًا',
        'حساس لاحتياجات الآخرين',
        'يستمتع بالانسجام بين الناس',
        'مراعٍ ومهتم',
        'متمسك بالمبادئ',
      ],
      weakSpotsWithOthers: [
        'حساس جدًا للصراعات',
        'يحتاج إلى التشجيع والتقدير',
        'يحتاج إلى وقت للمجاملة بين الأشخاص',
        'قد يرى النقد حيث لم يكن مقصودًا',
        'قد يكون حذرًا جدًا ويفشل في التصرف بشكل عفوي',
      ],
    },
    typeTagLine: '--',
    typeSneakPeek: 'نوع %fname يسمى INFJ. بعض الكلمات المرتبطة به هي المثابر، المهتم، الودود',
    typeKeywords: [
      '1. متمسك بالمبادئ',
      '2. مبدع',
      '3. متأمل',
      '4. منظم',
      '5. مثابر',
      '6. ضميري',
      '7. متعاطف',
      '8. ودود',
      '9. مهتم',
      '10. مسؤول',
      '11. متناغم',
    ],
    typePersonalStrengths: [
      'جيد في النظر إلى المشاكل من منظور عالمي',
      'جيد في توفير المصداقية من خلال الأفكار والرؤى',
      'جيد في إلهام الآخرين من خلال أسلوب إيجابي، فكاهي، وإمكانية التنفيذ',
      'جيد في التفكير المفاهيمي والتجريدي',
      'غالبًا جيد في التعبير الإبداعي',
      'اتباع نهج ضميري في العمل',
      'منظم ومنهجي',
      'يولي اهتمامًا قويًا بالتفاصيل',
      'يبذل أفضل جهوده في عمله',
      'يحاول بشكل مستمر تحقيق النجاح',
      'جيد في تحديد الأهداف',
      'ينجز الأمور ويفعل كل ما هو مطلوب أو مرغوب',
      'حاسم في تنفيذ رؤيته',
      'لديه اهتمام قوي بخدمة الصالح العام',
      'جيد في تعزيز التغيير من خلال العلاقات',
      'جيد في التعليم ومساعدة الناس على الفهم',
      'لديه إحساس قوي بالواجب والمسؤولية',
      'يدرك أهمية الالتزام بالقواعد',
      'يكمل المهام في الوقت المحدد وبمستوى عالٍ',
      'جيد في فهم المبادئ النظرية التي تقوم عليها المشاكل',
    ],
    typeWeakSpots: [
      'التفتح أو الانفتاح أكثر في المواقف الاجتماعية',
      'أن يكون أكثر انتقائية بشأن مدى الحاجة للتفكير العميق في القرارات مقابل اتخاذ الإجراء بسرعة أكبر',
      'أن يكون أقل تجنبًا للصراع وأقل تركيزًا على الوصول إلى توافق الآراء',
      'التأقلم أكثر مع التواصل مع مجموعات أكبر',
      'قبول الانزعاج الناتج عن اتخاذ قرارات صعبة وغير شعبية',
    ],
    description:
      'يضع نوع INFJ قيمة على التعاطف والتعاون، ويميل إلى أن يكون جيدًا في حل المشكلات بفضل ابتكاره وشغفه بالحفاظ على تنظيم الأمور وإنجازها. وبصفته نوعًا منطوٍ، يميل INFJ إلى أن يكون حساسًا ومحافظًا، ومن المحتمل أن يحتفظ بمشاعره لنفسه. ومع ذلك، يظهر قدرًا كبيرًا من التعاطف مع رفاهية الآخرين، ومن المحتمل أن يكون لديه طبيعة عطوفة وعميقة. وبالاقتران مع رغبة INFJ في الحفاظ على التنظيم، فهذا يعني أنهم من المرجح أن يكونوا قادرين على إتمام المهام دون فقدان أسلوبهم الشخصي والدقيق. القدرة على الشعور بأنهم يحسنون الأمور أمر بالغ الأهمية بالنسبة لـ INFJ.',
    individualTypeByLetters: 'الحامي',
    individualDescription:
      'بصفته الحامي، يضع %fname قيمة على التعاطف والتعاون. من المرجح أن يكون %fname جيدًا في حل المشكلات، بفضل ابتكاره وشغفه بالحفاظ على تنظيم الأمور وإنجازها. كنوع منطوي، يميل %fname إلى أن يكون حساسًا ومحافظًا، ويميل إلى الاحتفاظ بمشاعره لنفسه. ومع ذلك، يظهر %fname قدرًا كبيرًا من التعاطف مع رفاهية الآخرين، ومن المحتمل أن يكون لديه طبيعة عطوفة وعميقة. وبالاقتران مع رغبته في الحفاظ على التنظيم، من المرجح أن يكون قادرًا على إتمام المهام دون فقدان أسلوبه الشخصي والدقيق. القدرة على الشعور بأنهم يحسنون الأمور أمر بالغ الأهمية بالنسبة لـ %fname.',
  },
  INFP: {
    shortDescription: 'المُثالي',
    atWorkParagraphs: {
      effectiveness: [
        'تعلم وممارسة كيفية أن تكون حازمًا',
        'عدم الانسحاب من الناس عندما تصبح الأمور مرهقة',
        'تحسين مهارات إدارة الوقت وتحديد الأولويات',
        'إدراك أن الآخرين قد يقدرون النتائج السريعة، حتى إذا لم تكن تلك النتائج مثالية بعد',
        'تطوير احترام صحي للتفاصيل والجانب العملي',
        'التعرف على قيمة الصداقات العفوية وبناء العلاقات',
        'عدم تعقيد أو فكرية المشاكل بشكل مفرط',
        'إدراك أنه لا يجب إرضاء الجميع',
        'التخطيط مسبقًا',
        'إظهار المزيد من الحزم',
        'إثارة الآخرين بأفكارهم حول إمكانيات الصورة الكبيرة',
      ],
      teamLeader: [
        'تقديم تحفيز ملهم',
        'التركيز على القيم المشتركة والقضايا الأساسية',
        'تعزيز روح الفريق والجهود الجماعية من خلال خلق جو إيجابي',
        'البحث عن توافق المجموعة لتسهيل تحقيق الأهداف',
        'امتلاك وعي قوي بنقاط قوة وضعف الأفراد',
        'دفع الناس لتحقيق إمكاناتهم',
        'تحدي وتحفيز الناس',
        'تشجيع فرقهم على النظر في إمكانيات جديدة',
        'الحفاظ على مستوى عالٍ من الروح المعنوية وحسن التعاون بسبب قدرتهم على "قراءة" الآخرين',
      ],
      conflicts: [
        'قد يواجهون مشاكل مع الأشخاص الذين يأخذون أنفسهم على محمل الجد جدًا',
        'قد ينزعجون من الأشخاص الذين يتطلبون الكثير من التفاصيل أو الذين تعيق المنطق التقني لديهم الفهم',
        'قد ينزعجون من الأشخاص الذين لا يعترفون عندما لا يفهمون فكرة ما',
        'قد ينزعجون من الأشخاص الذين لا يأخذون جميع الآراء بعين الاعتبار',
      ],
      stressAdvisor: [
        'لديهم حاجة متزايدة للكمال',
        'يصبحون محدودي النظر ويرون فقط ما يعتقدون أنه مهم',
        'يفقدون الواقعية والبساطة عند إكمال مهمة',
      ],
      workEnvironment: ['مستقبلية التفكير', 'تعكس قيمهم الخاصة', 'ستتيح العمل في فترات من النشاط المكثف'],
      underStress: [],
      underSevereStress: [],
    },
    atWorkTagLine: 'تعاوني للغاية',
    atWorkSneakPeek: 'إحدى الطرق التي يمكنهم من خلالها تحسين فعاليتهم في العمل هي تعلم وممارسة كيفية أن يكونوا حازمين',
    withOthersTagLine: '',
    withOthersSneakPeek: '',
    withOthersParagraphs: {
      strengths: [
        'ودود',
        'متسامح',
        'تعاوني',
        'داعم',
        'متعاطف',
        'غامض',
        'كريم في تقديم الملاحظات الإيجابية',
        'مراعي، مفكر وحنون',
        'وفي جدًا للأشخاص الذين تهتم بهم',
        'متقبل',
        'اهتمام حقيقي',
      ],
      weakSpotsWithOthers: [
        'يحتاج إلى نصيبه العادل من التشجيع والتقدير',
        'يفضل أن تكون العلاقات متناغمة ويكره الصراع',
        'عندما ينغمس كثيرًا فيما يفعله يصبح غير اجتماعي',
        'يميل إلى القيام بالكثير من الأمور في وقت واحد',
        'يميل إلى التعامل بشكل سيء مع الأشخاص الذين يهددون قيمه الشخصية',
        'حساس بشكل مفرط لمشاعر الآخرين ومزاج الفريق',
      ],
    },
    typeTagLine: 'منفتح الذهن، مفكر حر، فضولي فكريًا',
    typeSneakPeek: 'نوعهم يسمى INFP. لديهم ميل لعدم التعامل بشكل جيد مع الأشخاص الذين يهددون قيمهم الشخصية',
    typeKeywords: [
      '1. منفتح الذهن',
      '2. مفكر حر',
      '3. فضولي فكريًا',
      '4. متحمس للتعلم',
      '5. خيالي',
      '6. متفائل',
      '7. مدفوع بالقيم',
      '8. يطور نفسه',
      '9. مستكشف',
      '10. داعم',
      '11. متفكر',
      '12. "الصورة الكبرى"',
    ],
    typePersonalStrengths: [
      'مليء بالحماس',
      'مرن وقابل للتكيف',
      'أسلوب عمل مستقل',
      'مسؤول',
      'متعاون للغاية',
      'روح فريق قوية',
      'مستعد للمساهمة من أجل الصالح العام',
      'بصير ومبدع',
      'يهتم بعمق بكل ما يشارك فيه',
      'سرعة في رؤية الإمكانيات',
      'عامل محفز لتحويل الأفكار إلى واقع',
      'قادر على إنجاز العديد من الأمور قرب الموعد النهائي',
      'جيد في تعزيز التغيير',
      'مساهم نشيط في وحدة الفريق وانسجامه',
    ],
    typeWeakSpots: [
      'عدم السعي للكمال أو عدم المثالية الزائدة',
      'أن يكون أكثر واقعية',
      'تخفيف التمسك بالقيم الشخصية عندما لا يشاركها الآخرون',
    ],
    description:
      'من المرجح أن يكون INFP دافئًا ومتعاطفًا، ويقوده القضايا التي تهم قلبه، مقاتلًا من أجل ما يؤمن به. العمل وفق القيم الشخصية من المحتمل أن يكون مهمًا جدًا بالنسبة لـ INFP، وعندما لا يكون مدفوعًا بمثال أعلى أو في البحث عن معنى أعمق، فإنه يميل إلى التسويف والحلم. من المرجح أن يكون INFP فضوليًا ومنفتح الذهن، ذو نهج مرن، ويستمتع بالعمل ضمن فريق بحيث يمكنه المساعدة في تقديم أفكار جديدة ومساعدة الآخرين على التطور والنمو. بمجرد التزامه بقضية يؤمن بها، من المرجح أن يكون INFP مخلصًا وملتزمًا للغاية.',
    individualTypeByLetters: 'المُثالي',
    individualDescription:
      'بصفته مُثاليًا، من المرجح أن يكون %fname فردًا دافئًا ومتعاطفًا، يقوده القضايا التي تهم قلبه ويقاتل من أجل ما يؤمن به. العمل وفق القيم الشخصية من المحتمل أن يكون مهمًا جدًا بالنسبة لـ %fname. عندما لا يكون مدفوعًا بمثال أعلى أو في البحث عن معنى أعمق، يميل %fname إلى التسويف والحلم. من المرجح أن يكون %fname فضوليًا ومنفتح الذهن، ذو نهج مرن، ويستمتع بالعمل ضمن فريق بحيث يمكنه المساعدة في تقديم أفكار جديدة ومساعدة الآخرين على التطور والنمو. بمجرد التزامه بقضية يؤمن بها، من المرجح أن يكون %fname مخلصًا وملتزمًا للغاية.',
  },
  INTJ: {
    shortDescription: 'عالِم',
    atWorkParagraphs: {
      effectiveness: [
        'قبول التواصل الشبكي كجزء ضروري من حياتهم المهنية، بما في ذلك التعارف النشط والمحادثات القصيرة أحيانًا',
        'التحلي بالدبلوماسية في صياغة الملاحظات، حتى لا يصبح الآخرون مدافعين للغاية',
        'عدم محاولة القيام بكل شيء بأنفسهم (حتى لو شعروا أنهم قد يقومون بعمل أفضل) ولكن تفويض المزيد للآخرين',
        'الانتباه للاحتياجات الشخصية بين الأشخاص – بما في ذلك احتياجاتهم الخاصة',
        'التأكد من منح الآخرين مساحة كافية لتقديم مساهماتهم في العملية',
        'التواصل بوضوح لإظهار تقديرهم لمساهمات الآخرين',
        'عدم إعطاء قيمة عالية جدًا للحصول على كل المعلومات قبل اتخاذ القرار، ولكن قبول أن بعض القرارات أفضل اتخاذها بشكل عفوي',
      ],
      teamLeader: [
        'ربط الفريق معًا بأفكار قوية وقناعات راسخة',
        'مساعدة الفريق على تحديد ما يريد تحقيقه بوضوح',
        'التأكد من أن الفريق يحقق هدفه ويظل على مسار العمل',
        'تحفيز الفريق من خلال وضع معايير عالية',
        'توفير بيئة عمل فعالة ومنظمة للفريق',
        'الوساطة في أي صراعات بطريقة موضوعية ومنطقية',
        'الانتباه للصورة الكبيرة واتخاذ زمام المبادرة لتغيير الاستراتيجية إذا لزم الأمر',
      ],
      teamLeaderFlipSide: [
        'قد يُنظر إليهم على أنهم جدليون للغاية، يركزون على المهام أو مسيطرون جدًا',
        'قد يظهرون أيضًا كأنهم متحفظون ومنفصلون جدًا',
      ],
      conflicts: [
        'قد تكون لديهم مشاكل مع الأشخاص الذين يتركون بعض المهام المتفق عليها غير مكتملة',
        'قد ينزعجون من الأشخاص الذين لا يولون اهتمامًا كافيًا أو لا يعطون وزنًا كافيًا لأسئلتهم أو مقترحاتهم',
        'قد ينزعجون من الأشخاص الذين ليسوا سريعين بما فيه الكفاية في متابعة أفكارهم ومقترحاتهم',
        'من المرجح أن يشعروا بالإحباط من الأشخاص الذين يركزون على تفاصيل غير مهمة أو يطالبون بإجابات فورية',
      ],
      workEnvironment: [
        'يوفر الاستقلالية',
        'يولي أهمية كبيرة للكفاءة',
        'منظم ويركز على المهام',
        'ليس روتينيًا، لكنه يوفر فرصة للتغيير وإعادة التصميم',
        'يخلق تحفيزًا فكريًا',
      ],
      stressAdvisor: [
        'قد يصبحون متصلبين بشكل متزايد، وانتقاديين تدريجيًا',
        'قد يكونون صارمين في آرائهم ووجهات نظرهم، ويجدون صعوبة في قبول أنهم مخطئون',
        'قد يصبحون غير صبورين ويبحثون عن الأخطاء حتى لو لم تكن موجودة',
      ],
    },
    atWorkTagLine: '---',
    atWorkSneakPeek: 'إحدى الطرق لتعزيز فعالية عملهم هي بعدم محاولة القيام بكل شيء بأنفسهم',
    withOthersTagLine: '---',
    withOthersSneakPeek: 'قد يشعرون براحة أكبر عند تولي الأدوار التالية في فريقهم: المنظم الدقيق، مولد الأفكار، الناقد',
    withOthersParagraphs: {
      strengths: [
        'مستقل',
        'متشكك',
        'ناقد',
        'معايير عالية للكفاءة والأداء لأنفسهم وللآخرين',
        'هادئ',
        'ملاحظ',
        'مصمم',
        'مبدئي',
        'جادل',
        'موثوق',
        'مفكر',
        'منطقي',
      ],
      weakSpotsWithOthers: [
        'قد يكون أحيانًا متعمق التفكير أكثر من اللازم',
        'فهم مشاعر الآخرين قد لا يكون طبيعيًا دائمًا',
        'بما أنهم يُنظر إليهم على أنهم هادئون، قد يفاجأ الزملاء عندما يعبرون عن آرائهم بقوة',
        'قد يكون عنيدًا أكثر من اللازم أحيانًا',
      ],
    },
    typeTagLine: '--',
    typeSneakPeek: 'نوعهم يُسمى INTJ. قد يصفهم الآخرون بأنهم مثابرون، مهتمون، أو ودودون',
    typeKeywords: [
      '1. منطقي',
      '2. كفؤ',
      '3. ملتزم بالواجب',
      '4. موجه نحو الهدف',
      '5. طموح',
      '6. صاحب أفكار',
      '7. منهجي',
      '8. منظم',
      '9. جدير بالثقة',
      '10. فردي',
      '11. ذو مبادئ',
    ],
    typePersonalStrengths: [
      'جيد في تقديم النصائح',
      'ينجز الأمور',
      'موجه نحو الأهداف',
      'يحقق النتائج كما هو متوقع',
      'يتبنى منظوراً طويل الأمد ويحل المشاكل بحلول دائمة',
      'شعور قوي بالواجب والمسؤولية',
      'قوي في التفكير المنهجي والمنظم',
      'قوي في التحليل المنطقي والموضوعي',
      'قادر على التعلم بمفرده',
      'نهج منهجي ومنظم لحل المشاكل',
      'تحديد معايير عالية لأنفسهم وللآخرين',
      'قادر على اتخاذ قرارات صعبة',
      'أصلي',
      'قادر على إتمام الأمور حتى النهاية',
      'جيد في تطوير النظريات والنماذج والأفكار أو الأنظمة الجديدة',
      'جيد في إتمام المهام بمعايير عالية وفي الوقت المحدد',
      'جيد في الالتزام بالطرق والإجراءات المعتمدة',
      'دقيق في التفاصيل',
      'العمل مع المفاهيم والنظريات المعقدة',
      'موثوق',
      'غير تقليدي',
      'فضول فكري',
    ],
    typeWeakSpots: [
      'قد يزعج الآخرين بسبب تركيزه الضيق جداً في السعي وراء مهمة أو هدف',
      'يفضل أن يكون هو المسؤول، أحياناً يتحمل عبئًا أكبر من اللازم',
    ],
    description:
      'من المحتمل أن يكون INTJ سريعًا ومبدعًا مع عقل استراتيجي. من المحتمل أن يستمتع بقضاء وقته في التفكير وتحليل المعلومات بطريقة مدروسة ومتأنية. الأنظمة والاستراتيجيات من المرجح أن تكون مهمة لـ INTJ، مع التنظيم والتخطيط كجزء رئيسي في مساعدتهم على فهم كيفية عمل الأشياء. الأفكار المجردة والمشاكل المنطقية تجذب INTJ، وسيمضي وقتًا في التفكير في هذه المفاهيم وتساؤلها. مع تركيزه على الأمور الملموسة والعقلانية، يمتلك INTJ رؤية وابتكارًا وقدرة على العمل نحو تحقيق النتائج. لا يميل INTJ إلى مشاركة عواطفه مع الآخرين بسهولة.',
    individualTypeByLetters: 'عالم',
    individualDescription:
      'بصفته عالمًا، من المحتمل أن يكون %fname سريعًا ومبدعًا مع عقل استراتيجي. من المحتمل أن يستمتع %fname بقضاء الوقت في التفكير وتحليل المعلومات بطريقة مدروسة ومتأنية. الأنظمة والاستراتيجيات من المرجح أن تكون مهمة بالنسبة له، مع التنظيم والتخطيط كجزء رئيسي في مساعدته على فهم كيفية عمل الأشياء. الأفكار المجردة والمشاكل المنطقية تجذب %fname، الذي من المحتمل أن يقضي وقتًا في التفكير في هذه المفاهيم وتساؤلها. مع تركيزه على الأمور الملموسة والعقلانية، من المحتمل أن يكون %fname لديه رؤية وابتكار وقدرة على العمل نحو تحقيق النتائج. %fname لا يميل إلى مشاركة عواطفه مع الآخرين بسهولة.',
  },
  INTP: {
    shortDescription: 'مفكر',
    atWorkParagraphs: {
      effectiveness: [
        'بذل جهد واعٍ للتواصل مع الناس بشكل أكثر تكرارًا',
        'التعرف على قيمة الانخراط في الأحاديث الجانبية',
        'استخدام لغة أكثر بساطة',
        'تقليص الأمور إلى فرضية منطقية',
        'مراعاة مشاعر الناس وعواطفهم بشكل أكثر في تحليل القضايا واعتبارات المهام',
        'تعلم تقنيات إدارة الوقت',
        'التركيز على الجوانب العملية',
      ],
      teamLeader: [
        'يستخدم المنطق والعقل لتوجيه أعضاء الفريق في الاتجاه الصحيح',
        'يضع أطر عمل تمكّن جميع أعضاء الفريق من استخدام مهاراتهم',
        'يُنظر إليه كمصدر للمعرفة والكفاءة، ويعمل كمورد نشط للآخرين',
        'يحدد جدول الأعمال ويحافظ على تركيز الآخرين عليه',
        'يوفر خيارات حتى تعكس القرارات الآراء المختلفة، مما يؤدي إلى الحل الأفضل والأكثر قبولًا',
        'يتفوق في تلخيص وتعميم المعلومات',
        'يحفيز فريقه من خلال وضع معايير عالية',
      ],
      conflicts: [
        'من المحتمل أن يشعر بالإحباط من أعضاء الفريق الذين يفتقرون إلى التركيز وغير المنطقيين في نهجهم',
        'من المحتمل أن يجد أعضاء الفريق الذين يتجادلون من منطلق الجهل محبطين',
        'من المحتمل أن يشعر بالإحباط من أعضاء الفريق الذين يتخذون التعليقات الموضوعية بشكل شخصي، ويشعرون بالجرح أو الإساءة من المنطق',
        'من المحتمل أن يواجه صعوبات عند العمل مع أشخاص يفتقرون إلى الرؤية والاستثمار في المشروع',
        'قد يكون لديه تحمل منخفض للأشخاص الذين يتحدثون كثيرًا ويركزون على القضايا غير الضرورية على حساب المهمة الأكبر',
      ],
      stressAdvisor: [
        'قد يصبح ساخرًا وغير صبور',
        'قد يفرط في تحليل الأمور بشكل متزايد، ويخوض في مناقشات لا نهائية',
        'قد يصبح جامدًا في وجهات نظره. قد يصبح أكثر استقلالية وسلبية',
      ],
      workEnvironment: ['بيئة تشجع على الأفكار والإبداع', 'حيث تكون هناك فترات أقل من المقاطعات وتتطلب إشرافًا محدودًا'],
    },
    atWorkTagLine: '---',
    atWorkSneakPeek:
      'إحدى الطرق التي يمكن لـ %fname من خلالها تعزيز فعاليته في العمل هي من خلال بذل جهد واعٍ للتواصل مع الناس بشكل أكثر تكرارًا.',
    withOthersTagLine: '---',
    withOthersSneakPeek: '%fname قد يشعر بأكبر قدر من الراحة في اتخاذ الأدوار التالية في فريقه: مولد الأفكار، الناقد، المنظم',
    withOthersParagraphs: {
      strengths: [
        'يستمتع بتحدي نفسه والآخرين',
        'يفضل التحدث عن الأفكار بدلاً من الأحاديث الجانبية',
        'منفتح الفكر، حر التفكير، ومتسامح',
        'يقدر المنطق والتفكير العقلاني',
        'يمكن أن يكون متحمسًا',
        'ودود وذو بصيرة',
        'مفكر',
        'يفضل التواصل الكتابي',
        'من المحتمل أن يُنظر إليه على أنه مفكر عميق',
      ],
      weakSpotsWithOthers: [
        'قد يظهر في البداية هادئًا ومنطويًا',
        'قد يظهر وكأنه كثير الجدال',
        'قد يُنظر إليه على أنه بارد ومنغلق',
        'قد يُعتبر غير عملي، غير منظم، وذو طابع مشتت الذهن',
      ],
    },
    typeTagLine: '--',
    typeSneakPeek: 'نوعه يُسمى INTP وبعض الكلمات المرتبطة هي: visionary (رؤيوي)، competitive (تنافسي)، analytical (تحليلي)',
    typeKeywords: [
      '1. رؤيوي',
      '2. كفاءة',
      '3. فضول',
      '4. خبير',
      '5. على دراية',
      '6. منطقي',
      '7. متحمس',
      '8. تنافسي',
      '9. مفكر',
      '10. مرن',
      '11. تحليلي',
      '12. شخص يركز على الصورة الكبيرة',
    ],
    typePersonalStrengths: [
      'جيد في تطبيق المعرفة',
      'جيد في حل المشكلات بحلول دائمة',
      'متفوق',
      'من المحتمل أن يصبح خبيرًا في مجال معين',
      'غالبًا ما يمتلك قدرة غير عادية في حل المشكلات المعقدة في مجاله المفضل',
      'جيد في إدراك الأنماط والعلاقات ورؤية الصورة الكبيرة',
      'قوي في تطوير النظريات والنماذج والأفكار أو الأنظمة الجديدة',
      'جيد في توفير الرؤية النقدية والبصيرة الفكرية',
      'قوي في حل المشكلات المفاهيمية',
      'جيد في جمع البيانات بطريقة محايدة',
      'تحليلي للغاية',
      'مبدع وخيالي',
      'يستمتع بالتساؤل وانتقاد ترتيب الأمور',
      'مرن وقابل للتكيف',
      'يستمتع بفرص الإبداع',
      'يستمتع بالتعقيد',
      'مستقل',
      'مهندس التغيير',
      'مصمم الأنظمة',
    ],
    typeWeakSpots: [
      'إظهار شك أقل وانتقاد أقل',
      'التواصل بشكل أكثر انفتاحًا أو ودية',
      'استكشاف اهتمامات أخرى. العمل في مهنة تمكنهم من استخدام اهتماماتهم بشكل جيد',
      'قبول المزيد من الأشخاص الذين ليسوا بنفس الكفاءة',
      'التوافق أكثر في بعض الحالات',
      'قد يواجهون في بعض الأحيان شكوكًا في النفس',
      'قد يفضلون العمل بمفردهم',
      'جيدون في إيجاد حلول إبداعية وجديدة، لكنهم أقل حماسًا عندما يكونون مسؤولين عن التنفيذ',
    ],
    description:
      'من المحتمل أن يستمتع INTP بالتفكير وحل المشكلات نظرًا لأنهم يميلون إلى امتلاك عين جيدة للتفاصيل وموهبة في فهم الأفكار المجردة والمشكلات المنطقية.  من المحتمل أن يكون INTP هادئًا ومفكرًا، ويفضل إبقاء مشاعره لنفسه.  كأفراد موضوعيين وواقعيين، يميلون إلى الاستمتاع بالمناقشات مع الآخرين، مما يتيح لهم التساؤل واكتشاف الحقيقة، لكنهم في بعض الأحيان قد يظهرون وكأنهم غامضين أو قد يتجاهلون احتياجات الآخرين إذا كانوا غارقين في ما يرونه مهمًا.',
    individualTypeByLetters: 'مفكر',
    individualDescription:
      'بصفته مفكرًا، من المحتمل أن يستمتع %fname بالتفكير وحل المشكلات نظرًا لأن لديهم ميلًا لامتلاك عين جيدة للتفاصيل وموهبة في فهم الأفكار المجردة والمشكلات المنطقية.  من المحتمل أن يكون %fname هادئًا ومفكرًا، ويفضل إبقاء مشاعره لنفسه.  كفرد موضوعي وواقعي، %fname يميل إلى الاستمتاع بالمناقشات مع الآخرين، مما يتيح له التساؤل واكتشاف الحقيقة. لكن %fname قد يظهر في بعض الأحيان وكأنه غامض أو قد يتجاهل احتياجات الآخرين إذا كان مغمورًا في ما يراه %fname مهمًا.',
  },
  ISFJ: {
    shortDescription: 'مربِّي',
    atWorkParagraphs: {
      effectiveness: [
        'عدم أن يكونوا حساسين جدًا ومهتمين بالتناغم',
        'مدح مهاراتهم ومساهمات الآخرين بشكل أكثر تكرارًا بدلاً من التقليل من شأنها',
        'الاستعداد لتوصيل رسالة قاسية عند الضرورة',
        'عدم أخذ ملاحظات الآخرين على محمل الجد أو شخصيًا، بل السماح لها بالمرور بشكل أكثر تكرارًا',
        'التمسك برأيهم إذا كانوا مقتنعين أنهم على صواب، بدلاً من السير مع الأغلبية من أجل تناغم الفريق',
      ],
      teamLeader: [
        'يعمل بجد ودائمًا ما يكون مستعدًا',
        'يميل إلى الاستماع إلى جميع الأفكار، وجمع الجميع معًا للحصول على دعم عام للحل',
        'يجعل الآخرين يعملون معًا ضمن النظام وي stick إلى القواعد التي وضعوها',
        'يشجع الآخرين على تطوير مهارات القيادة الخاصة بهم كلما أمكن',
        'يصر على الدقة والتحديد',
      ],
      conflicts: [
        'من المحتمل أن يشعر بالإحباط من أعضاء الفريق الذين يتحدثون كثيرًا في نظرهم، أو يقاطعون، أو لا يستمعون إلى الآخرين',
        'من المحتمل أن ينزعج من أعضاء الفريق الذين يقللون من شأن الآخرين وأفكارهم',
        'قد يشعر بالإحباط من الأشخاص الذين في نظرهم يقضون وقتًا طويلاً على الأجندات الشخصية وبالتالي يهملون مهام الفريق وأهداف الاجتماع',
        'قد يحدث صراع مع الأشخاص الذين في نظرهم يفتقرون إلى الحس السليم',
        'من المحتمل أن يواجه صعوبة مع الأشخاص الذين في نظرهم غير مستعدين للتعاون أو مشاركة المعلومات ذات الصلة',
      ],
      stressAdvisor: [
        'يجد صعوبة بالغة في قول لا، ويصبح متشائمًا بشكل متزايد إذا لم تسير الأمور على ما يرام',
        'يصبح قلقًا بشكل متزايد، وبالتالي يصبح أكثر تصلبًا في تفكيره في محاولة للسيطرة على الوضع',
        'قد يشعر بالإحباط إذا لم يُشعر بالتقدير',
      ],
      workEnvironment: ['يفضل بيئة متناغمة لتجنب الصراع', 'يفضل التنظيم الهيكلي مع أدوار ومهام محددة'],
    },
    atWorkTagLine: '---',
    atWorkSneakPeek: 'إحدى الطرق التي يمكن لـ %fname من خلالها تعزيز فعاليته في العمل هي من خلال الاستعداد لتوصيل رسالة قاسية عند الضرورة.',
    withOthersTagLine: '---',
    withOthersSneakPeek: '%fname قد يشعر بأكبر قدر من الراحة في اتخاذ الأدوار التالية في الفريق: المدقق، المنظم، الناقد',
    withOthersParagraphs: {
      strengths: [
        'ودود ومسؤول',
        'مراعٍ ومهتم، ودائمًا هناك عندما يحتاج إليهم الآخرون',
        'دفء هادئ وفكاهة لطيفة',
        'يتذكر التفاصيل عن الأشخاص الذين يعتبرهم مهمين',
        'جيد في تهدئة النزاعات',
        'مخلص، مراعي، وحدسي',
        'مهتم بمشاعر الآخرين',
        'هادئ في تفكيره، متعاطف وحساس',
        'يحب أن يكون دقيقًا في المحادثات، ويتوقع نفس الشيء من الآخرين',
      ],
      weakSpotsWithOthers: [
        'رغبة قوية في الاستقرار',
        'قد يكون حساسًا بشكل مفرط',
        'قد يركز كثيرًا على الحاضر والمستقبل القريب',
        'كره قوي للنزاع، وبالتالي تفضيل حاد للعلاقات المنسجمة',
        'حساس تجاه مشاعر الآخرين ومزاج الفريق',
      ],
    },
    typeTagLine: '--',
    typeSneakPeek: '%fname نوعه يُسمى ISFJ. بعض الكلمات المرتبطة هي: عملي، منظم، دقيق',
    typeKeywords: [
      '1. عملي',
      '2. منهجي',
      '3. موثوق',
      '4. واقعي',
      '5. مراعٍ',
      '6. حساس',
      '7. دقيق',
      '8. منظم',
      '9. حاسم',
      '10. ودود',
      '11. مستقر',
      '12. دقيق',
    ],
    typePersonalStrengths: [
      'مستعد للقيام بما يجب فعله في اللحظة نفسها',
      'عملي ولديه حس سليم جيد',
      'جيد في إتمام المهام إلى مستوى عالٍ',
      'يأخذ العمل على محمل الجد ولديه شعور قوي بالمسؤولية',
      'مراقب واقعي للبيئة',
      'يفضل التعلم من خلال العمل',
      'اهتمام قوي بالتفاصيل',
      'ذاكرة جيدة وقدرة قوية على التمكن من الحقائق',
      'صبر في جمع التفاصيل اللازمة',
      'مهارات تنظيم جيدة',
      'يوفر الاستقرار لأي مشروع أو مجموعة',
      'نهج منهجي ودقيق',
      'حاسم',
      'مخلص للغاية عندما يُشعر بالانتماء',
      'جيد في خلق النظام',
      'جيد في تقديم المعلومات الخلفية بشكل استجابة وضميري',
    ],
    typeWeakSpots: [
      'محاولة أن يكون أكثر انفتاحًا أو ودية',
      'أن يكون أكثر تقبلًا للنزاع وعدم محاولة البحث عن التناغم دائمًا',
      'أن يكون أقل اعتمادًا على السلطة',
      'الاحتضان أكثر للتغيير',
      'قبول أنه في بعض الأحيان يشعر بعدم الراحة مع الفوضى والشك',
    ],
    description:
      'من المحتمل أن يكون ISFJ فردًا مراعًٍا ومتعاونًا يسعى للشعور بأنه مفيد وذو قيمة. هم مخلصون وصبورون؛ شخص لا يستسلم عند أول عقبة. ومع ذلك، من المحتمل أن يكونوا خجولين إلى حد ما وأفراد هادئين. يفكرون في الآخرين قبل أنفسهم ويقدمون دعمًا ودودًا وعمليًا، ويفضلون النهج الشخصي. يحبون العناية بالتفاصيل اليومية العملية، ويتجنبون لفت الأنظار إليهم.',
    individualTypeByLetters: 'مربِّي',
    individualDescription:
      'بصفتهم مربّيًا، من المحتمل أن يُنظر إلى %fname على أنه فرد مراعٍ ومتعاون. %fname يحب أن يشعر بأنه مفيد وذو قيمة، ومن المحتمل أن يكون مخلصًا وصبورًا؛ شخص لا يستسلم عند أول عقبة. %fname من المحتمل أن يكون خجولًا إلى حد ما وفردًا هادئًا، يفكر في الآخرين قبل نفسه، ويقدم دعمًا ودودًا وعمليًا، ويفضل النهج الشخصي. %fname من المحتمل أن يعتني بالتفاصيل اليومية العملية ويتجنب لفت الأنظار إليه.',
  },
  ISFP: {
    shortDescription: 'فنان',
    atWorkParagraphs: {
      effectiveness: [
        'عدم التحفظ كثيرًا وأخذ الفضل عندما يكون ذلك مستحقًا',
        'عدم التقليل من مهاراتهم ومساهماتهم',
        'عدم أخذ تعليقات الآخرين على محمل الجد، مع الاعتراف بأن بعض الأشخاص لا يفكرون قبل التحدث',
        'الاستمرار في التصرف بلطف، مع تعلم كيفية إظهار بعض الحزم عند الضرورة',
        'عدم القلق كثيرًا بشأن التناغم',
        'تعلم كيفية إيصال رسالة قاسية عند الحاجة',
        'عدم أن يكونوا ناقدين لأنفسهم بشكل مفرط',
        'تعلم تقنيات إدارة الوقت',
        'تعلم كيفية قول "لا"',
        'ممارسة إعطاء تعليقات سلبية',
      ],
      teamLeader: [
        'يلهم الآخرين ليتبعوا قاعدة العمل الجاد والتحضير المستمر',
        'يستمع بعناية لجميع الأفكار والهموم، ثم يحصل على الدعم العام لحل مع إقناع لطيف وفعال',
        'يظهر اهتمامًا صادقًا بوجهات النظر الأخرى',
        'يمنح الآخرين حرية كبيرة في تحديد أهدافهم الخاصة',
        'يتقدم فقط بالقرارات إذا تم الوصول إلى إجماع',
      ],
      conflicts: [
        'من المحتمل أن يشعر بالانزعاج من الأشخاص الذين يتحدثون كثيرًا',
        'من المحتمل أن يتصادم مع الأشخاص الذين يقللون من شأن الآخرين وأفكارهم',
        'قد يشعر بالإحباط من الأشخاص الذين يفتقرون إلى الحس السليم',
        'قد ينزعج من الأشخاص الذين يعيقون تقدم الفريق بعدم مشاركة المعلومات المهمة',
        'لا يقدر الأشخاص الذين هم أنانيون ولا يرغبون في التعاون',
      ],
      stressAdvisor: [
        'قد يصبح أكثر تشتتًا، ويواجه صعوبة في إدارة الوقت وترك الآخرين يتخذون السيطرة لتجنب المسؤولية',
        'قد يأخذ الانتقادات بشكل شخصي، حتى وإن كانت مجرد اختلاف في الآراء',
        'يأخذ وقتًا لاتخاذ القرار، ويغير رأيه كثيرًا',
      ],
      workEnvironment: ['بيئة مرنة مع إشراف قليل', 'يفضل بيئة داعمة وذات معنى ليشعر بالراحة'],
    },
    atWorkTagLine: '---',
    atWorkSneakPeek: 'إحدى الطرق التي يمكن لـ %fname من خلالها تعزيز فعاليته في العمل هي من خلال عدم التقليل من مهاراته ومساهماته.',
    withOthersTagLine: '---',
    withOthersSneakPeek: '%fname قد يشعر بأكبر قدر من الراحة في اتخاذ الأدوار التالية في الفريق: الوسيط، المنظم، المدقق',
    withOthersParagraphs: {
      strengths: [
        'ودود وهادئ، دافئ وداعم',
        'مخلص وملتزم تجاه الأشخاص المهمين',
        'حساس',
        'لطيف',
        'منفتح الذهن',
        'يظهر فكاهة لطيفة',
        'غير قاضٍ أو متعصب',
        'مراعي',
        'من غير المرجح أن ينتقد الآخرين بدون سبب',
        'لا يفرض آرائه أو قيمه على الآخرين',
      ],
      weakSpotsWithOthers: [
        'قد يستغرق وقتًا ليفتح قلبه للأشخاص الجدد',
        'يتجنب الخلافات',
        'مندفع',
        'ليس صريحًا أو حازمًا جدًا',
        'قد ينسحب من الناس في حالات الضغط',
      ],
    },
    typeTagLine: '--',
    typeSneakPeek: '%fname نوعه يُسمى ISFP. بعض الكلمات المرتبطة هي: عملي، مراعٍ، مرن',
    typeKeywords: [
      '1. عملي',
      '2. منفتح الذهن',
      '3. مستقل',
      '4. لطيف',
      '5. إيجابي',
      '6. مراعٍ',
      '7. هادئ',
      '8. عملي',
      '9. مرن',
      '10. واقعي',
      '11. مخلص',
    ],
    typePersonalStrengths: [
      'يفضل العمل على الكلام',
      'مهتم بإيجاد حلول عملية وملموسة للمشاكل الواقعية',
      'متسامح، منفتح الذهن وقابل لقبول وجهات نظر الآخرين',
      'قادر على العمل بشكل مستقل وفي إطار زمني خاص بهم',
      'مرن وقابل للتكيف، لا يتعلق بالأفكار القديمة',
      'مخلص وملتزم',
      'جيد في جعل الآخرين يعملون معًا ضمن النظام',
      'جيد في تقديم المعلومات الخلفية بشكل استجابة وضمير',
      'يستمتع بالتجربة العملية',
      'واقعي',
      'جيد في الاستجابة للأزمات وحل المشكلات',
      'مراعٍ وجيد في توقع تأثير الأفعال على الآخرين',
      'مستقل التفكير',
      'موقف إيجابي',
      'جيد في الشمولية وحل النزاعات',
      'يفضل العمل بطريقة متساوية',
      'يمتلك قيمًا ومثاليّات قوية',
      'جيد في التواصل الواحد لواحد',
      'جيد في رؤية الصورة العامة',
      'مستعد لتجاوز القواعد عند الحاجة',
      'جيد في الملاحظة الدقيقة',
    ],
    typeWeakSpots: [
      'يجب أن يكون أكثر إلحاحًا في إنجاز الأمور',
      'يجب أن يكون أكثر انفتاحًا أو مشاركة لأفكارهم',
      'يجب أن يقدر أكثر المواقف التي تتضمن خلافات وصراعات. حاول ألا تسعى دائمًا للتسوية والإجماع',
      'يجب أن يقدر الروتين والأنظمة أكثر، بدلاً من الحرية أو المساحة',
      'يجب أن يكون أقل تواضعًا بشأن قدراتهم',
      'يجب أن يتخذ القيادة أكثر',
      'يجب أن يولي مزيدًا من الاهتمام للتفاصيل',
    ],
    description:
      'الـ ISFP هو شخص هادئ وودود ومريح. هم متعاونون، يفضلون دور الدعم لتعزيز تناغم الفريق. موجهون للعمل، يفضلون الأنشطة العملية لاستخدام إبداعهم بشكل جيد، ومع ذلك، من المحتمل أن يتجنبوا الأنشطة التنظيمية والتخطيطية، ويفضلون أسلوبًا أكثر مرونة وعفوية ويتجنبون التوقعات المستقبلية. هم مستمعون جيدون، متسامحون وحساسون لاحتياجات الآخرين، سيقدمون نصائح عملية ودعمًا حيثما أمكن.',
    individualTypeByLetters: 'فنان',
    individualDescription:
      'كفنان، من المحتمل أن يكون %fname شخصًا هادئًا وودودًا ومريحًا. يميل %fname إلى أن يكون متعاونًا، ويستمتع بدور الدعم من أجل تعزيز تناغم الفريق. %fname موجه للعمل، يفضل الأنشطة العملية لاستخدام إبداعه بشكل جيد. ومع ذلك، من المحتمل أن يتجنب الأنشطة التنظيمية والتخطيطية، ويفضل أسلوبًا مرنًا وعفويًا، ويتجنب وضع خطط للمستقبل. من المحتمل أن يكون %fname مستمعًا جيدًا، متسامحًا وحساسًا لاحتياجات الآخرين، ومريحًا في تقديم النصائح العملية والدعم كلما كان ذلك ممكنًا.',
  },
  ISTJ: {
    shortDescription: 'مفتش',
    atWorkParagraphs: {
      effectiveness: [
        'التأكد من إبقاء الناس على اطلاع ومواكبة',
        'تطوير مهارات الشبكات والتواصل',
        'محاولة خلق لحظات ممتعة خلال يوم العمل',
        'التعرف على قيمة الحديث القصير',
        'طلب التعليقات بشكل أكثر انتظامًا',
        'تشجيع وتقدير الإبداع',
        'تطوير مهارات التواصل بين الأشخاص',
        'تذكير النفس بعدم التعمق في التفاصيل الفردية وفقدان المعنى العام للمهمة',
        'النظر إلى ما وراء الأنظمة القائمة',
        'تفويض المزيد من المهام وتقليل الإدارة الدقيقة',
        'المشاركة في المحادثات في بداية العملية، وعرض وجهات نظرهم في وقت مبكر بدلاً من الانتظار حتى يصبح الوقت متأخرًا.',
        'تعليق الحكم النقدي خلال جلسات العصف الذهني',
      ],
      teamLeader: [
        'يغرس الثقة في فريقه من خلال الحجج المنطقية، والمعرفة التفصيلية لموضوعه ونظرة واقعية',
        'منفتح على الحقائق والحجج المنطقية',
        'ينظم ويحافظ على هيكل فعال دون الحاجة للحديث كثيرًا',
        'يدير اجتماعات فعالة ومركزة للغاية',
        'واضح فيما يتعلق بما هو متوقع، وما المهام التي تحتاج إلى إتمام وما هو المستوى المطلوب',
      ],
      conflicts: [
        'من المحتمل أن يزعجه أعضاء الفريق الذين يعتبرهم كثيري الحديث والدردشة',
        'قد يشعر بالإحباط من الأشخاص الذين يراهم غير موثوقين ويفتقرون إلى المتابعة',
        'من المرجح أن يكون لديه تسامح قليل مع الأشخاص الذين يريدون مناقشة القضايا الشخصية أو غير المتعلقة بالعمل',
      ],
      stressAdvisor: [
        'قد يصبح شديد التركيز وغير مرن، مطالبًا باتباع القواعد والهياكل',
        'قد يجد صعوبة في قبول أنه قد يكون مخطئًا، وأيضًا عدم إعطاء الثناء الكافي للآخرين عندما يكون ذلك مستحقًا',
        'قد يصبح متشائمًا ومفرطًا في التدقيق في التفاصيل',
      ],
      workEnvironment: ['يفضل العمل مع وجود أهداف وإجراءات واضحة', 'يفضل العمل على مهمة أو مشروع واحد في وقت واحد، مع إشراف محدود'],
    },
    atWorkTagLine: '---',
    atWorkSneakPeek: 'إحدى الطرق التي يمكن لـ %fname تعزيز فعاليتهم في العمل هي من خلال التعرف على قيمة الحديث القصير',
    withOthersTagLine: '---',
    withOthersSneakPeek: '%fname قد يشعر بأكبر قدر من الراحة عند تولي الأدوار التالية في الفريق: الناقد، المخصص، المنظم',
    withOthersParagraphs: {
      strengths: [
        'يقدر التقاليد والولاء',
        'إحساس بالواجب',
        'واقعي',
        'هادئ ومستقل',
        'موثوق ويمكن الاعتماد عليه',
        'جاهز للمساعدة',
        'ثابت في آرائه',
        'يفضل التواصل كتابيًا بدلاً من إجراء مناقشات طويلة',
        'يعامل الناس باحترام',
      ],
      weakSpotsWithOthers: [
        'قد يبدو متحفظًا وغير عاطفي',
        'غير اجتماعي، يفضل إنجاز الأعمال بدلاً من الانخراط في المجاملات الاجتماعية',
        'من الصعب الاتصال والتواصل عاطفيًا',
        'قد يُنظر إليه على أنه غير خيالي وصلب',
        'بطيء في التكيف والتفاعل مع التغيير',
      ],
    },
    typeTagLine: '--',
    typeSneakPeek: 'نوع %fname يُسمى ISTJ. بعض الكلمات الرئيسية المرتبطة به هي: ثابت، موضوعي، حاسم',
    typeKeywords: [
      '1. دقيق',
      '2. حاسم',
      '3. عقلاني',
      '4. مسؤول',
      '5. محترم',
      '6. ثابت',
      '7. مفصل',
      '8. يمكن الاعتماد عليه',
      '9. منهجي',
      '10. ودود',
      '11. ملم بالمعلومات',
      '12. موضوعي',
    ],
    typePersonalStrengths: [
      'منظم ومرتب، سواء في المنزل أو العمل',
      'نظرة مسؤولة تجاه العمل',
      'ملتزم بإتمام المهام',
      'يُكمل المهام بدقة',
      'نظرة عملية وواقعية',
      'جيد في حل المشكلات باستخدام المنطق السليم',
      'يعمل بثبات نحو تحقيق الأهداف بغض النظر عن الانحرافات',
      'حاسم',
      'موضوعي وعقلاني',
      'مهارات تحليلية قوية',
      'ملتزم بالأشخاص والمنظمة التي ينتمي إليها',
      'منضبط ويستمتع بتطوير واتباع روتين',
      'دقيق ولديه إلمام ممتاز بالحقائق',
      'اهتمام ممتاز بالتفاصيل',
      'مستعد للعمل بشكل مستقل',
      'يقدر الالتزام بالإجراءات والعمليات المعتمدة',
      'جيد في تطبيق القوانين والسياسات',
      'جيد في توثيق الإجراءات والمعلومات',
      'يحب تحسين الأمور من خلال خطوات صغيرة',
      'معايير جودة عالية. جيد في تحديد الأخطاء وتصحيحها',
      'جيد في جلب المساءلة العالية لأي فريق',
      'مجتهد، ويلهم الآخرين للعمل الجاد لإتمام المهمة في الوقت المحدد',
    ],
    typeWeakSpots: ['تقدير أو قبول المزيد من عدم الاستقرار والفوضى', 'قبول المزيد من التغيير والابتكار', 'أن يكون أقل تمسكًا بالقوانين'],
    description:
      'الـ ISTJ هو فرد منهجي، يتمتع بالولاء والموثوقية. يفخر بالعمل الذي يقوم به، ويميل إلى الراحة في المهام الروتينية. يعتبر الـ ISTJ أشخاصًا جادين ومتفكرين، ويستمتعون بإنشاء وتنفيذ النظام. من المرجح أن يكونوا دقيقين ومنهجيين ومسؤولين، ويحبون التعامل مع الحقائق. تعتبر المسؤوليات مهمة بالنسبة لهم، وعندما يتعهدون بمشروع ما، يلتزمون بإجراءات العمل، مع التزام تام بالمواعيد النهائية ولا يتحملون التردد أو الكسل. الواجب مهم بالنسبة لهم، وعندما يلتزمون بمشروع ما، يتبعون إجراءات العمل، ويحرصون على أن تكون قراراتهم قائمة على الحقائق والمنطق.',
    individualTypeByLetters: 'المفتش',
    individualDescription:
      'باعتبارك مفتشًا، من المرجح أن تكون فردًا منهجيًا، يتمتع بالولاء والموثوقية. أنت تفخر بالعمل الذي تقوم به، وتميل إلى الراحة في المهام الروتينية. قد يُنظر إليك على أنك شخص جاد ومتأمل، وتستمتع بإنشاء وتنفيذ النظام؛ من المحتمل أن تكون دقيقًا ومنهجيًا ومسؤولًا وتحب التعامل مع الحقائق. على الأرجح، تقبل المسؤوليات وتستلم زمام الأمور لتنفيذ المهام، مع الالتزام بالمواعيد النهائية وقلة التسامح مع التردد والكسل. يُعتبر الواجب مهمًا بالنسبة لك، وعندما تلتزم بمشروع ما، تتابع الإجراءات لضمان أن القرارات تتخذ بناءً على الحقائق والمنطق.',
  },
  ISTP: {
    shortDescription: 'ميكانيكي',
    atWorkParagraphs: {
      effectiveness: [
        'الحرص على عدم العمل على العديد من المهام في وقت واحد. إتمام المهام الرئيسية قبل الانتقال إلى شيء جديد',
        'أن تكون أقل انتقائية بشأن التفاصيل المحددة',
        'الحذر من إعطاء انطباع بأنهم غير مبالين',
        'تركيز طاقاتهم على حل أزمة واحدة في كل مرة',
        'إنشاء هيكل ضيق يحد من خيارات العمل',
        'قضاء المزيد من الوقت في التحضير مسبقًا',
        'إعداد جدول أعمال للاجتماعات',
        'ممارسة مهارات الشبكات الاجتماعية',
        'النظر في احتياجات الزملاء الشخصية بشكل أكثر تكرارًا',
        'الاهتمام بتفاصيل العمل بشكل أكبر',
        'التعرف على قيمة الحديث القصير (small talk)',
      ],
      teamLeader: [
        'يتبع نهجًا عمليًا في القيادة',
        'يقود الفريق بسلطة هادئة وغير مباشرة',
        'يقيّم جميع الآراء ولكن مع نية واضحة للتحرك نحو التنفيذ',
        'يشجع الفريق على الاستمرار والتقدم',
        'يتعامل مع الأزمات والتغيرات بشكل جيد جدًا',
        'يعرف من أين يمكنه الحصول على المعلومات المطلوبة',
        'يحل المشاكل من خلال تطبيق المنطق والنظر في الحقائق أولاً',
      ],
      conflicts: [
        'من المحتمل أن يجد صعوبة في العمل مع أعضاء الفريق الذين يراهم عاطفيين للغاية بدلاً من أن يكونوا موضوعيين',
        'من المحتمل أن يواجه صعوبة مع الأشخاص الذين يعتقد أنهم يضيعون الطاقة على المهام التي هي خارج نطاق الفريق',
        'قد يشعر بالانزعاج من أعضاء الفريق الذين يعقدون اجتماعات معلوماتية بشكل متكرر حيث لا يكون الغرض العملي واضحًا',
      ],
      stressAdvisor: [
        'يمكن أن يكون عرضة لانفجارات عاطفية متهورة إذا كان تحت الضغط والتوتر',
        'قد يجد صعوبة في المتابعة وإتمام المهمة',
        'قد يصبح مفرط التركيز على التفاصيل الحالية، متجاهلاً الاحتمالات المستقبلية',
      ],
      workEnvironment: [
        'يبحث عن مرونة في الروتين ويحتاج إلى إشراف قليل لأنه يحب التصرف بشكل عفوي',
        'يستمتع باللعب بالأفكار وابتكار طرق جديدة لحل الأمور',
      ],
    },
    atWorkTagLine: '---',
    atWorkSneakPeek: 'إحدى الطرق التي يمكن لـ%fname تعزيز فعاليته في العمل هي بأن يكون أقل تركيزًا على التفاصيل الدقيقة',
    withOthersTagLine: '---',
    withOthersSneakPeek: '%fname قد يشعر بالراحة أكثر في شغل الأدوار التالية ضمن فريقه: الناقد، الدقيق، المنظم',
    withOthersParagraphs: {
      strengths: [
        'متسامح وذو عقلية منفتحة',
        'ومضات غير متوقعة من الفكاهة الأصلية',
        'يميل إلى تحليل الحياة بدافع الفضول',
        'يستمتع بالعيش في اللحظة',
        'موجه نحو العمل وعفوي',
        'محب للمرح',
        'عميق',
        'مفكر',
        'متأمل',
        'مستقل',
        'قد يفضل التواصل كتابةً',
        'عادل وموضوعي',
      ],
      weakSpotsWithOthers: [
        'قد يُنظر إليه على أنه متهور للغاية',
        'قد يشعر بالقيود بسهولة',
        'قد يتراجع في البداية قبل أن يكون مستعدًا للمساهمة',
        'الأشخاص الأكثر عاطفية قد يواجهون صعوبة في التعامل مع نهجه العقلاني للغاية',
        'قد يُنظر إليه على أنه محجوب',
      ],
    },
    typeTagLine: '--',
    typeSneakPeek: "%fname's النوع يُسمى ISTP. بعض الكلمات المرتبطة به هي موضوعي، منطقي، أو متسامح",
    typeKeywords: [
      '1. واقعي',
      '2. منطقي',
      '3. تحليلي',
      '4. واقعي',
      '5. مرن',
      '6. عملي',
      '7. متسامح',
      '8. مستقل',
      '9. موضوعي',
      '10. عادل',
      '11. محلل للمشاكل',
    ],
    typePersonalStrengths: [
      'جيد في فهم كيفية عمل الأشياء',
      'جيد في تحريك الفريق نحو العمل',
      'تركيز قوي على الحلول العملية',
      'مُعالِج طبيعي للمشاكل: سريع في إيجاد حلول قابلة للتطبيق',
      'جيد في استخدام مهارات التحليل لتنظيم العمل بكفاءة',
      'مرن وقابل للتكيف',
      'جيد في تنظيم الحقائق واستخدام المبادئ المنطقية',
      'نهج عملي وواقعي ومباشر',
      'تفكير منطقي قوي',
      'جيد في التخطيط',
      'مستعد للإثارة والمغامرة',
      'جيد في الاستجابة للأزمات',
      'يقدّر المنطق والتفكير العقلاني',
      'مستعد لاتخاذ الإجراءات',
      'استجابة مثابرة',
      'جيد في العمل بشكل مستقل',
      'مستعد لكسر القواعد إذا لم تكن منطقية',
      'واقعي يركز على الحلول',
      'مريح عند العمل مع الحقائق والبيانات الصلبة',
    ],
    typeWeakSpots: [
      'حاول ألا تقف جانباً وتراقب',
      'حاول أن تظهر أقل انفصالاً',
      'لا تتجاهل الروتين في سعيك وراء التنوع والإثارة',
      'زيادة الاهتمام بالنظريات المجردة',
    ],
    description:
      'من المرجح أن يكون الـ ISTP مائلًا إلى دور يتطلب العمل الفعلي. يحب أن يكون متورطًا بشكل عملي، وحماسيًا للغاية ومتفاعلاً مع المشروع. الـ ISTP هو شخص هادئ نسبيًا، يفضل المرونة على التنظيم، ويترك فضوله يقوده إلى أماكن جديدة. يميل إلى أن يكون منطقيًا وعمليًا، مع عطش للمعرفة، لكنه ليس مرتاحًا جدًا مع التخطيط والتنظيم، ويفضل اتباع نهج أكثر مرونة.',
    individualTypeByLetters: 'ميكانيكي',
    individualDescription:
      'كـ ميكانيكي، من المرجح أن يكون %fname مائلًا إلى دور يتطلب العمل الفعلي. يحب أن يكون متورطًا بشكل عملي، وحماسيًا للغاية ومتفاعلاً مع المشروع. %fname يميل إلى أن يكون شخصًا هادئًا نسبيًا، يفضل المرونة على التنظيم ويترك فضوله يقوده إلى أماكن جديدة. %fname أكثر منطقية وعملية، ولديه عطش للمعرفة، لكنه ليس مرتاحًا جدًا مع التخطيط أو التنظيم. يفضل اتباع نهج أكثر مرونة.',
  },
};

export const tmiTypeGroupsAr: { name: string; types: string[] }[] = [
  {
    name: 'الحرفيون',
    types: ['ISFP', 'ESTP', 'ESFP', 'ISTP'],
  },
  {
    name: 'الحراس',
    types: ['ESTJ', 'ISTJ', 'ESFJ', 'ISFJ'],
  },
  {
    name: 'المثاليون',
    types: ['ENFJ', 'INFJ', 'ENFP', 'INFP'],
  },
  {
    name: 'العقلانيون',
    types: ['ENTJ', 'INTJ', 'ENTP', 'INTP'],
  },
];

export const spectrumTraitsAr: {
  [trait: string]: {
    imageUrl: string;
    left: {
      title: string;
      description: string;
    };
    right: {
      title: string;
      description: string;
    };
  };
} = {
  OPPORTUNITY_AWARENESS: {
    imageUrl: lightningImageUrl,
    left: {
      title: 'واعٍ بالفرص',
      description: 'يحدد الإمكانيات والفرص',
    },
    right: {
      title: 'تصنيفي',
      description: 'يرى الأمور بشكل واضح ومحدد',
    },
  },
  ACTION_ORIENTATION: {
    imageUrl: lightningImageUrl,
    left: {
      title: 'مبادر',
      description: 'ذو نشاط، يبدأ الأعمال بنفسه',
    },
    right: {
      title: 'متردد',
      description: 'يفكر قبل التصرف، صبور',
    },
  },
  DRIVE: {
    imageUrl: lightningImageUrl,
    left: {
      title: 'متقبل',
      description: 'منتظم، أقل تطلبًا',
    },
    right: {
      title: 'طموح',
      description: 'يسعى للإنجاز، يتحدى نفسه، يفضل الضغط العالي',
    },
  },
  SELF_EFFICACY: {
    imageUrl: lightningImageUrl,
    left: {
      title: 'قلق',
      description: 'قد يرى الأهداف الصعبة بعيدة المنال وغير قابلة للتحقيق',
    },
    right: {
      title: 'واثق',
      description: 'يؤمن بقدراته على مواجهة التحديات الجديدة',
    },
  },
  PERSISTENCE: {
    imageUrl: courtImageUrl,
    left: {
      title: 'فوري',
      description: 'يسعى لتحقيق المكاسب الفورية والقابلة للتحقيق',
    },
    right: {
      title: 'مثابر',
      description: 'يواصل المهام الصعبة، قد يهمل الأمور الفورية',
    },
  },
  ORDERLINESS: {
    imageUrl: courtImageUrl,
    left: {
      title: 'منظم',
      description: 'مرتب، مخطط، منضبط',
    },
    right: {
      title: 'مرن',
      description: 'يفعل الأمور بشكل عملي وعشوائي عند الحاجة',
    },
  },
  CAUTIOUSNESS: {
    imageUrl: courtImageUrl,
    left: {
      title: 'حذر',
      description: 'آمن، حذر، تقليدي، روتيني',
    },
    right: {
      title: 'اندفاعي',
      description: 'تجريبي، يتحدى، محفوف بالمخاطر، غير رسمي',
    },
  },
  DUTIFULNESS: {
    imageUrl: courtImageUrl,
    left: {
      title: 'مخلص',
      description: 'يكمل المهام بجدية، يتبع القواعد',
    },
    right: {
      title: 'مرن في الواجبات',
      description: 'ينظر للواجبات بطريقة أكثر مرونة، ويقبل التعديل',
    },
  },
  ALTRUISM: {
    imageUrl: shuffleImageUrl,
    left: {
      title: 'إيثاري',
      description: 'لطيف، كريم، من أجل الصالح العام',
    },
    right: {
      title: 'مبادلة عادلة',
      description: 'يعامل بالمثل، "مصلحة مقابل مصلحة"',
    },
  },
  COOPERATION: {
    imageUrl: shuffleImageUrl,
    left: {
      title: 'متعاون',
      description: 'منسجم، متنازل، مراعي',
    },
    right: {
      title: 'تنافسي',
      description: 'عنيد، أقل استعدادًا للتنازل',
    },
  },
  ETHICS: {
    imageUrl: shuffleImageUrl,
    left: {
      title: 'صريح',
      description: 'طبيعي، صريح، لا يرى حاجة للتظاهر',
    },
    right: {
      title: 'محافظ',
      description: 'مهذب، مؤدب، يعتقد أن بعض التظاهر ضروري',
    },
  },
  ASSERTIVENESS: {
    imageUrl: peopleImageImageUrl,
    left: {
      title: 'متكيف',
      description: 'حازم، يوضح موقفه',
    },
    right: {
      title: 'حازم',
      description: 'حازم، يوضح موقفه',
    },
  },
  EMOTIONALITY: {
    imageUrl: compassImageUrl,
    left: {
      title: 'متعاطف',
      description: 'يظهر التعاطف لمشاعر الآخرين، مهتم',
    },
    right: {
      title: 'هادئ',
      description: 'غير متأثر بالمشاعر، لامبالي',
    },
  },
  GROUNDEDNESS: {
    imageUrl: compassImageUrl,
    left: {
      title: 'عملي',
      description: 'ملموس، محدد، واقعي، واضح',
    },
    right: {
      title: 'فضولي فكريًا',
      description: 'مفاهيمي، معقد، يستمتع بالنقاش، التفكير المجرد',
    },
  },
  IMAGINATION: {
    imageUrl: lightBulbImageUrl,
    left: {
      title: 'مقيد',
      description: 'منهجي، آلي، أقل إبداعًا',
    },
    right: {
      title: 'مبدع',
      description: 'خلاق، مرح، موجه بالأفكار',
    },
  },
  FRIENDLINESS: {
    imageUrl: peopleImageImageUrl,
    left: {
      title: 'جدي',
      description: 'جاد، قد يُنظر إليه على أنه أقل ودية',
    },
    right: {
      title: 'ودود',
      description: 'قابل للتعامل، سهل المعاملة',
    },
  },
  INDIVIDUALITY: {
    imageUrl: peopleImageImageUrl,
    left: {
      title: 'موجه نحو المجموعة',
      description: 'يجده أسهل للاندماج والالتزام بسلوك المجموعة',
    },
    right: {
      title: 'فردي',
      description: 'معتمد على نفسه، مستقل، فريد',
    },
  },
  SOCIABILITY: {
    imageUrl: peopleImageImageUrl,
    left: {
      title: 'منعزل',
      description: 'يستمتع بالوقت بمفرده، متحفظ',
    },
    right: {
      title: 'اجتماعي',
      description: 'منفتح، متحدث، يحب النشاط الاجتماعي',
    },
  },
};
